var _path, _path2, _path3, _path4, _path5, _polygon, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.9,335.25l-1.47,13.29c0,.17,0,.33-.07.5a5.86,5.86,0,0,1-5.81,4.57H613a2,2,0,0,1-2-2.44l3.08-16a2.26,2.26,0,0,1,2.19-1.79h8.93a1.68,1.68,0,0,1,1.67,1.87Z",
    style: {
      fill: "#242424"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.26,
    y: 196.33,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.32,
    y: 197.15,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.38,
    y: 196.19,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.44,
    y: 197.15,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.82,
    y: 238.53,
    width: 121.5,
    height: 160.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.35,
    y: 238.53,
    width: 56.97,
    height: 160.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.29,
    y: 260.23,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.29,
    y: 364.1,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.35,297.18c0,.3-14.45.54-32.26.54s-32.27-.24-32.27-.54,14.44-.54,32.27-.54S301.35,296.89,301.35,297.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.29,
    y: 312.56,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.35,349.52c0,.29-14.45.54-32.26.54s-32.27-.25-32.27-.54,14.44-.54,32.27-.54S301.35,349.22,301.35,349.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.45,
    y: 260.23,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.15,
    y: 260.23,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.45,
    y: 310.59,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.15,
    y: 310.59,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.45,
    y: 360.95,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.15,
    y: 360.95,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.35 241.28 301.35 226.83 313.45 226.83 313.45 218.9 329.83 218.9 329.83 211.82 358.32 211.82 358.32 240.14 301.35 241.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.81,
    y: 188.31,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.95,
    y: 188.31,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.33,
    y: 180.8,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.98,
    y: 180.8,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.15,
    y: 180.8,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.39,
    y: 224.32,
    width: 62.95,
    height: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.52,
    y: 211.32,
    width: 91.44,
    height: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.5,41.47h.06a.33.33,0,0,0,.3-.33v-.27h0V31.43a5.44,5.44,0,0,0-8.44-4.53L303.2,26a3,3,0,1,0-4.45,3.49,3,3,0,0,0,1.88.44L305,35.09v5.79h0v.27a.33.33,0,0,0,.2.3.31.31,0,0,0,.13,0h.11l-2.3,35.83h1.29l.51-7.88,5,6.54-1.05,1.34h1l.52-.67.51.67h1l-1-1.33L316,69.4l.52,7.91h1.3Zm-4.83,0,3.35,7h-7.33l3.45-7.05Zm.9,0h2.63l.42,6.42Zm-3.7,0h1.37l-2.91,5.93.38-5.93Zm-1.8,10L310,57.83l-4.81,7.58Zm.51-.72h7.91l-4,6.32Zm8.29.91.92,14L311,57.83Zm-4.41,6.93,4.71,7.64h-9.56Zm-5.26,9.87h10.55l-5.36,6.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.6,100.49h-1.29V108l-5.5-6.07,5.66-6h.67V94.09H306.53V95.9h.91l5.48,6-5.9,6.32v-7.77h-2.38V286.11H307v-1.58h12.29v1.59h2.38V100.49ZM307.44,255.58l5.48,6-5.9,6.31V255.59Zm.89,0h10.24l-5.2,5.56Zm-.7-1.81,5.73-6.13,5.55,6.13Zm-.61-.3V241.11h.42l5.48,6Zm1.31-12.36h10.24l-5.2,5.56Zm-.7-1.81,5.73-6.13,5.55,6.13ZM307,239V226.64h.42l5.48,6Zm1.31-12.36h10.24l-5.2,5.56Zm-.7-1.81,5.73-6.13,5.55,6.13Zm-.61-.31V212.17h.42l5.48,6Zm1.31-12.35h10.24l-5.2,5.57Zm-.7-1.81,5.73-6.13,5.55,6.12Zm-.61-.31V197.7h.42l5.48,6Zm1.31-12.35h10.24l-5.2,5.57Zm-.7-1.81,5.73-6.13,5.55,6.12Zm-.61-.31V183.23h.42l5.48,6Zm1.31-12.35h10.24l-5.2,5.57Zm-.7-1.81,5.73-6.13,5.55,6.12Zm-.61-.31V168.76h.42l5.48,6Zm1.31-12.35h10.24l-5.2,5.56Zm-.7-1.81,5.73-6.13,5.55,6.12Zm-.61-.31V154.28h.42l5.48,6.05Zm1.31-12.36h10.24l-5.2,5.56Zm-.7-1.81,5.73-6.13,5.55,6.13Zm-.61-.3V139.81h.42l5.48,6Zm1.31-12.36h10.24l-5.2,5.56Zm-.7-1.81,5.73-6.13,5.55,6.13Zm-.61-.3V125.34h.42l5.48,6Zm1.31-12.36h10.24l-5.2,5.56Zm-.7,142.91,5.73-6.13,5.55,6.12Zm6.18-6.62,5.5-5.88V267.7Zm0-14.47,5.5-5.89v12Zm0-14.47,5.5-5.89v12Zm0-14.47,5.5-5.89v12Zm0-14.47,5.5-5.89v12Zm0-14.47,5.5-5.89v12Zm0-14.48,5.5-5.88v12Zm0-14.47,5.5-5.89v12Zm0-14.47,5.5-5.89v12Zm0-14.47,5.5-5.89v12Zm5.32-7.87H307.4l6-6.38Zm-5.32-6.85,5.5-5.89v12ZM307,123V110.62h.42l5.48,6Zm0,147.08h.42l5.48,6-5.9,6.31Zm1.31,0h10.24l-5.2,5.57Zm11,.16v12l-5.5-6.08Zm-5.94-154-5-5.56h10.24Zm0,160.41,5.55,6.12H307.63Zm-5-180.69h10.24l-5.2,5.56Zm10.8,12.91H307.4l6-6.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.56,92,482.69,78.75a5,5,0,0,0-3-1H245.52v2.38h1.08V92.42h-1.09V94.8H499.71a1.43,1.43,0,0,0,1.43-1.42v-.24A1.43,1.43,0,0,0,500.56,92Zm-29-6.37-5.89-5.5h12Zm6.61-5.09V91.81L472,86.08Zm-12.66.34,5.56,5.2-5.56,5Zm-8.42,4.75-5.89-5.5h12Zm6.61-5.09V91.81l-6.13-5.73ZM451,80.88l5.57,5.2-5.56,5Zm-8.41,4.75-5.89-5.5h12Zm6.6-5.09V91.81l-6.13-5.73Zm-12.66.34,5.57,5.2-5.56,5Zm-8.41,4.75-5.89-5.5h12Zm6.6-5.09V91.81l-6.13-5.73Zm-12.66.34,5.57,5.2-5.56,5Zm-8.42,4.75-5.88-5.5h12Zm6.61-5.09V91.81l-6.13-5.73Zm-12.66.34,5.56,5.2-5.55,5Zm-8.42,4.75-5.89-5.5h12Zm6.61-5.09V91.81l-6.13-5.73Zm-12.66.34,5.56,5.2-5.56,5Zm-8.42,4.75-5.89-5.5h12Zm6.61-5.09V91.81l-6.13-5.73Zm-12.66.34,5.56,5.2-5.56,5Zm-8.42,4.75-5.89-5.5h12Zm6.61-5.09V91.81l-6.13-5.73Zm-12.67.34,5.57,5.2-5.56,5Zm-1.8,10.93-6.13-5.73,6.12-5.54Zm1.81.19,6-5.47,6.32,5.89H364.19Zm14.47,0,6-5.47L391,92.42H378.66Zm14.47,0,6.05-5.47,6.31,5.89H393.13Zm14.48,0,6-5.47L420,92.42H407.61Zm14.47,0,6-5.47,6.31,5.89H422.08Zm14.47,0,6-5.47,6.31,5.89H436.55ZM451,92l6-5.47,6.31,5.89H451Zm14.47,0,6-5.47,6.32,5.89H465.49ZM361.84,80.13l-6.07,5.5-5.89-5.5h12Zm-113.43.75,5.57,5.2-5.56,5Zm.17-.75h12l-6.07,5.5Zm92.72,5.5-5.89-5.5h12Zm6.6-5.09V91.81l-6.13-5.73Zm-12.66.34,5.57,5.2-5.56,5Zm-8.41,4.75-5.89-5.5h12Zm6.6-5.09V91.81l-6.13-5.73Zm-12.66.34,5.57,5.2-5.56,5Zm-8.42,4.75-5.88-5.5h11.95ZM319,80.54V91.81l-6.13-5.73Zm-12.66.34,5.56,5.2-5.56,5Zm-8.42,4.75L292,80.13h12Zm6.61-5.09V91.81l-6.12-5.73Zm-12.66.34,5.56,5.2-5.56,5Zm-8.42,4.75-5.89-5.5h12ZM290,80.54V91.81l-6.13-5.73Zm-12.66.34,5.56,5.2-5.56,5Zm-8.42,4.75-5.89-5.5h12Zm6.61-5.09V91.81l-6.13-5.73Zm-12.67.34,5.57,5.2-5.56,5Zm-1.81-.34V91.81L255,86.08ZM262.89,92l6-5.47,6.31,5.89H262.89Zm14.47,0,6-5.47,6.32,5.89H277.36Zm14.47,0,6.05-5.47,6.31,5.89H291.83Zm14.48,0,6-5.47,6.31,5.89H306.31Zm14.47,0,6-5.47,6.31,5.89H320.78Zm14.47,0,6-5.47,6.31,5.89H335.25Zm14.46-11.12,5.57,5.2-5.56,5ZM248.42,92l6-5.47,6.31,5.89H248.42Zm101.3.42V92l6-5.47,6.31,5.89H349.72Zm130.24,0V80.16a5.35,5.35,0,0,1,2.78.94L499,92.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.71,77.54c.14,7.92-.12,31.83-.12,31.83h28.72l-.77-4.72a4,4,0,0,1,0-1.46l2.1-10.41-5.15-16A2.46,2.46,0,0,0,320.18,75h-20A2.46,2.46,0,0,0,297.71,77.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.89 77.31 310.89 94.8 324.63 94.8 326.05 92.91 320.72 77.31 310.89 77.31",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.68,77.75s-.22,0-.65-.15l-1.88-.52-7.23-2-26.54-7.58L355.85,42.25,301.37,26.48l.22-.05C286,41.06,272.75,53.34,263.43,61.93c-4.65,4.3-8.34,7.67-10.88,10-1.26,1.14-2.25,2-2.92,2.59s-1,.83-1,.83l.25-.23c.17-.15.43-.35.75-.66l2.87-2.64,10.79-10.05,38-35.64.1-.1.12,0L356,41.75,443.48,67.1,470,74.85l7.2,2.13,1.87.56C479.47,77.67,479.68,77.75,479.68,77.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.53,74.35a2.82,2.82,0,0,0-2.21,1.07c-1.33,1.65-3.34,4.68-3.53,5s-.09,10.48,0,15.53a2.82,2.82,0,0,0,2.82,2.79H259a2.83,2.83,0,0,0,2.82-2.83V77.16A2.83,2.83,0,0,0,259,74.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.32,32a3.79,3.79,0,1,1-3.78-3.79A3.78,3.78,0,0,1,314.32,32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.58,27a2.11,2.11,0,1,1-2.11-2.11A2.11,2.11,0,0,1,302.58,27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.36,116h.74l.29-4.5,2.92,3.74-.57.76h.58l.29-.38.29.38h.59l-.59-.76,2.82-3.73L150,116h.73l-1.31-20.39h.06l.08,0a.18.18,0,0,0,.11-.17v-.15h0V92l2.48-3a1.71,1.71,0,1,0-.76-3.15,1.69,1.69,0,0,0-.7.91l-2.4.53a3.11,3.11,0,0,0-4.81,2.58v5.37h0v.16a.18.18,0,0,0,.17.18h0Zm4.38-20.39,2,4h-4.17l1.9-4Zm-2.54,3.65.23-3.66h1.5Zm4.5-3.65.21,3.37-1.65-3.37h1.44Zm.87,13.61-2.74-4.31,2.23-3.62Zm-3-4.74-2.29-3.6h4.5Zm-.27.43-2.76,4.47.52-8Zm3,4.79h-5.44l2.68-4.34Zm-2.72,5.16-3-3.9h6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.17,129.2V234.83h1.36v-.9h7v.9h1.35V129.2h-1.35v4.42L145.17,130l3.11-3.44h.52v-1h-7.74v1h.38l3.22,3.45-3.13,3.46V129.2h-1.36Zm8.35,88.26v7l-3.35-3.59,3.11-3.44Zm-3.61,3.16-3-3.16h5.83Zm-3.15-4.19,3.15-3.49,3.26,3.49Zm3.41-3.77,3.11-3.44h.24v7Zm-.26-.27-3-3.17h5.83Zm-3.15-4.2,3.15-3.48,3.26,3.48Zm3.41-3.76,3.11-3.44h.24v7Zm-.26-.28L142,201h5.83ZM141.76,200l3.15-3.49,3.26,3.49Zm3.41-3.77,3.11-3.44h.24v7Zm-.26-.27-3-3.17h5.83Zm-3.15-4.2,3.15-3.48,3.26,3.48Zm3.41-3.76,3.11-3.44h.24v7Zm-.26-.28-3-3.17h5.83Zm-3.15-4.2,3.15-3.48,3.26,3.49Zm3.41-3.76,3.11-3.44h.24v7Zm-.26-.27-3-3.17h5.83Zm-3.15-4.2,3.15-3.49,3.26,3.49Zm3.41-3.76,3.11-3.44h.24v7Zm-.26-.28L142,168h5.83Zm-3.15-4.2,3.15-3.48,3.26,3.49Zm3.41-3.76,3.11-3.44h.24v7Zm-.26-.27-3-3.17h5.83Zm-3.15-4.2,3.15-3.49,3.26,3.49Zm3.41-3.76,3.11-3.44h.24v7Zm-.26-.28-3-3.17h5.83Zm-3.15-4.2,3.15-3.48,3.26,3.49Zm3.41-3.76,3.11-3.44h.24v7Zm-.26-.27-3-3.17h5.83Zm-3.15,78.15,3.15-3.48,3.26,3.49Zm-.23-.3v-6.81l3.13,3.35Zm0-8.24v-6.8l3.13,3.35Zm0-8.23v-6.81l3.13,3.35Zm0-8.24v-6.8l3.13,3.35Zm0-8.24v-6.8l3.13,3.35Zm0-8.23v-6.81l3.13,3.36Zm0-8.24v-6.8l3.13,3.35Zm0-8.23V159.9l3.13,3.35Zm0-8.24v-6.8l3.13,3.35Zm0-8.23v-6.81l3.13,3.35Zm3.38-11.56,3.39,3.63h-6.67Zm-3.38,3.18v-6.8l3.13,3.35Zm3.64-3.46,3.11-3.43h.24v7Zm3.35,94.33-3.35-3.6,3.11-3.43h.24Zm-3.61-3.87-3-3.17h5.83Zm-.25.28-3.13,3.45v-6.8ZM142,135h5.83l-2.87,3.17Zm6.22,97.94h-6.41l3.15-3.49Zm-3.26-103.15-3-3.16h5.83Zm0,.56,3.39,3.63h-6.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.05,125v.13a.82.82,0,0,0,.82.81H183.52v-1.35h-.62v-7h.62v-1.35H50.27a2.89,2.89,0,0,0-1.72.57l-10.17,7.54A.82.82,0,0,0,38.05,125Zm13.39-7.41h6.81l-3.35,3.13ZM54.62,121l-3.49,3.26v-6.42Zm3.72,2.86L55.18,121l3.16-3Zm1.34-6.25h6.8l-3.35,3.13ZM62.86,121l-3.49,3.26v-6.42Zm3.71,2.86L63.41,121l3.17-3Zm1.34-6.25h6.81l-3.35,3.13ZM71.09,121l-3.49,3.26v-6.42Zm3.72,2.86L71.65,121l3.16-3Zm1.34-6.25H83l-3.35,3.13ZM79.33,121l-3.49,3.26v-6.42Zm3.72,2.86L79.88,121l3.17-3Zm1.33-6.25h6.81l-3.35,3.13ZM87.56,121l-3.48,3.26v-6.42Zm3.72,2.86L88.12,121l3.16-3Zm1.34-6.25h6.8l-3.35,3.13ZM95.8,121l-3.49,3.26v-6.42Zm3.72,2.86L96.35,121l3.17-3Zm1.33-6.25h6.81l-3.35,3.13ZM104,121l-3.48,3.26v-6.42Zm3.72,2.86L104.59,121l3.17-3Zm1.34-6.25h6.81l-3.36,3.13Zm3.18,3.39-3.49,3.26v-6.42Zm3.72,2.86L112.82,121l3.17-3Zm1-6,3.49,3.16L117,124.26Zm-1,6.77h-7l3.59-3.36,3.44,3.12Zm-8.24,0h-7l3.59-3.36,3.44,3.12Zm-8.23,0h-7l3.59-3.36,3.44,3.12Zm-8.24,0h-7l3.59-3.36,3.44,3.12Zm-8.23,0H76l3.59-3.36,3.44,3.12Zm-8.24,0h-7l3.59-3.36,3.44,3.12Zm-8.24,0h-7l3.6-3.36,3.43,3.12Zm-8.23,0h-7l3.59-3.36,3.44,3.12Zm59.29-7h6.5l-3.35,3.13-3.45-3.13Zm64.24,6.25L178.71,121l3.16-3Zm-3.44-3.12L175,117.61h6.81Zm-52.87-3.13h6.81L129,120.74Zm3.18,3.39-3.49,3.26v-6.42Zm3.72,2.86L129.29,121l3.17-3Zm1.34-6.25h6.8l-3.35,3.13ZM137,121l-3.49,3.26v-6.42Zm3.71,2.86L137.53,121l3.17-3Zm1.34-6.25h6.81l-3.35,3.13Zm3.18,3.39-3.49,3.26v-6.42Zm3.72,2.86L145.76,121l3.17-3Zm1.34-6.25h6.8l-3.35,3.13Zm3.18,3.39L150,124.26v-6.42Zm3.71,2.86L154,121l3.17-3Zm1.34-6.25h6.81L162,120.74Zm3.18,3.39-3.49,3.26v-6.42Zm3.72,2.86L162.24,121l3.16-3Zm1.34-6.25h6.8l-3.35,3.13Zm3.18,3.39-3.49,3.26v-6.42Zm3.71,2.86L170.47,121l3.17-3Zm4.52-2.86-3.49,3.26v-6.42Zm-4.52,3.61h-7l3.6-3.36,3.43,3.12Zm-8.23,0h-7l3.59-3.36,3.44,3.12Zm-8.24,0h-7l3.6-3.36,3.43,3.12Zm-8.23,0h-7l3.59-3.36,3.44,3.12Zm-8.24,0h-7l3.59-3.36,3.44,3.12Zm-8.23,0h-7l3.59-3.36,3.44,3.12Zm-8.24-.75L121.06,121l3.17-3Zm57.65.75h-7l3.59-3.36,3.44,3.12Zm-64.24,0h-.44l3.59-3.36,3.44,3.12v.24Zm-78.37,0,9.27-6.44a3,3,0,0,1,1.58-.54v7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.82,116.14c-.08,4.51.07,18.11.07,18.11H137.54l.44-2.68a2.31,2.31,0,0,0,0-.83l-1.2-5.93,2.93-9.12a1.4,1.4,0,0,1,1.33-1h11.39A1.4,1.4,0,0,1,153.82,116.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.32 116.01 146.32 125.96 138.5 125.96 137.69 124.89 140.73 116.01 146.32 116.01",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.27,116.26a1.59,1.59,0,0,1,.35-.13l1.06-.33,4.09-1.24,15.07-4.44,49.78-14.46,31-8.93.13,0,.09.09,29.92,28.09a7.11,7.11,0,0,1-.61-.46c-.38-.33-.95-.82-1.67-1.46-1.45-1.3-3.56-3.21-6.21-5.65-5.32-4.88-12.84-11.86-21.75-20.18l.23.06-31,9L71,110.48l-15.12,4.28-4.12,1.14-1.07.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,114.32a1.6,1.6,0,0,1,1.25.61c.76.94,1.9,2.67,2,2.84s0,6,0,8.83a1.61,1.61,0,0,1-1.6,1.59H175.84a1.61,1.61,0,0,1-1.61-1.61V115.92a1.61,1.61,0,0,1,1.61-1.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.37,90.23a2.15,2.15,0,1,0,2.15-2.16A2.15,2.15,0,0,0,144.37,90.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.25,
    cy: 87.4,
    r: 1.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.3,
    y: 146.02,
    width: 83.22,
    height: 252.64,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.91,
    y: 146.02,
    width: 41.61,
    height: 251.91,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.81,
    y: 120.13,
    width: 29.39,
    height: 25.89,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 649.19,
    y: 120.13,
    width: 7,
    height: 25.89,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "610.37 146.02 610.37 144.51 702.96 144.51 702.96 146.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.73,
    y: 157.32,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.91,178c0,.16-9.31.28-20.8.28s-20.81-.12-20.81-.28,9.32-.28,20.81-.28S658.91,177.84,658.91,178Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.7,
    y: 157.32,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.89,178c0,.16-9.32.28-20.81.28s-20.8-.12-20.8-.28,9.31-.28,20.8-.28S700.89,177.84,700.89,178Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.7,
    y: 186.81,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.89,207.49c0,.16-9.32.29-20.81.29s-20.8-.13-20.8-.29,9.31-.28,20.8-.28S700.89,207.34,700.89,207.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.7,
    y: 217.19,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.89,237.87c0,.16-9.32.29-20.81.29s-20.8-.13-20.8-.29,9.31-.28,20.8-.28S700.89,237.72,700.89,237.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.7,
    y: 247.57,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.89,268.25c0,.16-9.32.29-20.81.29s-20.8-.13-20.8-.29,9.31-.28,20.8-.28S700.89,268.1,700.89,268.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.7,
    y: 277.08,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.89,297.76c0,.16-9.32.29-20.81.29s-20.8-.13-20.8-.29,9.31-.28,20.8-.28S700.89,297.61,700.89,297.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.7,
    y: 306.71,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.7,
    y: 336.73,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.89,327.4c0,.15-9.32.28-20.81.28s-20.8-.13-20.8-.28,9.31-.29,20.8-.29S700.89,327.24,700.89,327.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.73,
    y: 187.26,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.91,207.94c0,.16-9.31.29-20.8.29s-20.81-.13-20.81-.29,9.32-.28,20.81-.28S658.91,207.79,658.91,207.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.73,
    y: 217.2,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.91,237.88c0,.16-9.31.29-20.8.29s-20.81-.13-20.81-.29,9.32-.28,20.81-.28S658.91,237.73,658.91,237.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.73,
    y: 247.14,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.91,267.82c0,.16-9.31.29-20.8.29s-20.81-.13-20.81-.29,9.32-.28,20.81-.28S658.91,267.67,658.91,267.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.73,
    y: 277.08,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.91,297.76c0,.16-9.31.29-20.8.29s-20.81-.13-20.81-.29,9.32-.28,20.81-.28S658.91,297.61,658.91,297.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.73,
    y: 307.02,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.91,327.71c0,.15-9.31.28-20.8.28s-20.81-.13-20.81-.28,9.32-.29,20.81-.29S658.91,327.55,658.91,327.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.73,
    y: 336.96,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.76,
    y: 165.55,
    width: 122.89,
    height: 233.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.03,
    y: 165.55,
    width: 57.62,
    height: 233.23,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.52,
    y: 187.49,
    width: 11.05,
    height: 26.85,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.52,
    y: 292.56,
    width: 11.05,
    height: 26.85,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,224.87c0,.24-14.61.42-32.64.42s-32.63-.18-32.63-.42,14.61-.41,32.63-.41S120,224.64,120,224.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.52,
    y: 240.43,
    width: 11.05,
    height: 26.85,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,277.81c0,.23-14.61.42-32.64.42s-32.63-.19-32.63-.42,14.61-.42,32.63-.42S120,277.58,120,277.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.26,
    y: 187.49,
    width: 11.05,
    height: 26.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.24,
    y: 187.49,
    width: 11.05,
    height: 26.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.26,
    y: 238.43,
    width: 11.05,
    height: 26.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.24,
    y: 238.43,
    width: 11.05,
    height: 26.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.26,
    y: 289.37,
    width: 11.05,
    height: 26.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.24,
    y: 289.37,
    width: 11.05,
    height: 26.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.52,
    y: 159.9,
    width: 141.37,
    height: 5.84,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.51,166.3c0,.23-27.47.42-61.34.42s-61.35-.19-61.35-.42,27.46-.42,61.35-.42S178.51,166.07,178.51,166.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.21,
    y: 195.49,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.27,
    y: 196.31,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.33,
    y: 195.34,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.39,
    y: 196.31,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.77,
    y: 237.69,
    width: 121.5,
    height: 160.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.3,
    y: 237.69,
    width: 56.97,
    height: 160.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.25,
    y: 259.38,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.25,
    y: 363.26,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.3,296.34c0,.3-14.44.54-32.26.54s-32.27-.24-32.27-.54,14.45-.54,32.27-.54S583.3,296,583.3,296.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.25,
    y: 311.72,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.3,348.67c0,.3-14.44.54-32.26.54s-32.27-.24-32.27-.54,14.45-.54,32.27-.54S583.3,348.38,583.3,348.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.4,
    y: 259.38,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.1,
    y: 259.38,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.4,
    y: 309.75,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.1,
    y: 309.75,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.4,
    y: 360.11,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.1,
    y: 360.11,
    width: 10.92,
    height: 26.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.3 240.43 583.3 225.99 595.4 225.99 595.4 218.06 611.78 218.06 611.78 210.98 640.27 210.98 640.27 239.3 583.3 240.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.76,
    y: 187.46,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.9,
    y: 187.46,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.29,
    y: 179.96,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.93,
    y: 179.96,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.11,
    y: 179.96,
    width: 1,
    height: 53.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520.35,
    y: 223.48,
    width: 62.95,
    height: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520.48,
    y: 210.48,
    width: 91.44,
    height: 1,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.61,483.27c0,.15-102.36.26-228.6.26s-228.62-.11-228.62-.26S248.73,483,375,483,603.61,483.13,603.61,483.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.25,398.78c0,.14-155.48.26-347.23.26s-347.27-.12-347.27-.26,155.45-.26,347.27-.26S722.25,398.64,722.25,398.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.19,
    y: 353.74,
    width: 2.44,
    height: 44.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.88,352.21a2.47,2.47,0,1,1-2.47-2.46A2.47,2.47,0,0,1,117.88,352.21Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.73,
    y: 353.74,
    width: 2.44,
    height: 44.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.42,352.21a2.46,2.46,0,1,1-2.46-2.46A2.46,2.46,0,0,1,166.42,352.21Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.21,
    y: 358.08,
    width: 62.59,
    height: 11.2,
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.29 358.08 114.19 358.26 107.76 369.28 107.21 369.28 107.21 358.08 114.29 358.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.11 358.08 123.57 369.28 115.02 369.28 117.62 364.83 121.56 358.08 130.11 358.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.93 358.08 139.38 369.28 130.83 369.28 137.38 358.08 145.93 358.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.74 358.08 155.19 369.28 146.64 369.28 153.19 358.08 161.74 358.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.8 358.08 169.8 369.28 162.46 369.28 169 358.08 169.8 358.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.21,
    y: 375.38,
    width: 62.59,
    height: 11.2,
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.29 375.38 114.19 375.56 107.76 386.58 107.21 386.58 107.21 375.38 114.29 375.38",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.11 375.38 123.57 386.58 115.02 386.58 117.62 382.13 121.56 375.38 130.11 375.38",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.93 375.38 139.38 386.58 130.83 386.58 137.38 375.38 145.93 375.38",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.74 375.38 155.19 386.58 146.64 386.58 153.19 375.38 161.74 375.38",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.8 375.38 169.8 386.58 162.46 386.58 169 375.38 169.8 375.38",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8,369.28s0-.07,0-.2v-.56c0-.5,0-1.22,0-2.17,0-1.91,0-4.7,0-8.27l.07.06-62.58.06h0l.13-.12c0,3.83,0,7.6,0,11.2l-.12-.13,44.56.06,13.21,0,3.57,0h0l-3.54,0-13.18,0-44.65.06h-.12V358h.13l62.58.06h.07v.07c0,3.59,0,6.39,0,8.3,0,.95,0,1.67,0,2.17v.54C169.8,369.22,169.8,369.28,169.8,369.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8,386.58s0-.07,0-.2v-.56c0-.5,0-1.22,0-2.17,0-1.91,0-4.7,0-8.27l.07.06-62.58.06h0l.13-.12c0,3.83,0,7.6,0,11.2l-.12-.13,44.56.06,13.21,0,3.57,0h0l-3.54,0-13.18,0-44.65.06h-.12V375.25h.13l62.58.06h.07v.07c0,3.59,0,6.39,0,8.3,0,.95,0,1.67,0,2.17v.54C169.8,386.52,169.8,386.58,169.8,386.58Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.84,457.74l1.05,24.68-30.71,1.46c0-2.94,15.65-9.58,15.65-9.58l-1.32-15.79Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.26,472.52a1.26,1.26,0,0,1,.94,1.39,1.2,1.2,0,0,1-1.37.93,1.32,1.32,0,0,1-1-1.47,1.26,1.26,0,0,1,1.54-.82",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.89,482.42l-.11-2.49-29.46,2.34s-1.34.66-1.14,1.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M451.32,474.16c0,.15.77.19,1.53.63s1.18,1.06,1.32,1-.13-.93-1.06-1.45S451.28,474,451.32,474.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.17,475.65c0,.15.63.37,1.17,1s.72,1.27.87,1.26.2-.87-.48-1.61S448.16,475.51,448.17,475.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.52,479.59c.14,0,.31-.73-.11-1.53s-1.14-1.1-1.2-1,.4.54.73,1.21S446.37,479.58,446.52,479.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.42,470.53c.07.14.75-.1,1.6-.09s1.52.26,1.6.13-.59-.64-1.6-.65S451.34,470.42,451.42,470.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,466.85a2.76,2.76,0,0,0,1.54-.08,6.64,6.64,0,0,0,1.58-.57,5.89,5.89,0,0,0,.86-.51,2.11,2.11,0,0,0,.45-.38.64.64,0,0,0,0-.8.8.8,0,0,0-.67-.31,1.82,1.82,0,0,0-.57.1,5.38,5.38,0,0,0-.95.38,5.44,5.44,0,0,0-1.37,1c-.68.7-.9,1.27-.84,1.3s.39-.44,1.09-1a6.35,6.35,0,0,1,1.33-.84,6,6,0,0,1,.87-.31c.33-.11.6-.12.69,0s0,.08,0,.17a1.35,1.35,0,0,1-.33.28,8.77,8.77,0,0,1-.79.51,9.18,9.18,0,0,1-1.46.64A10,10,0,0,0,452,466.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.19,467.06a2.51,2.51,0,0,0,.33-1.5,5,5,0,0,0-.29-1.68,4.74,4.74,0,0,0-.44-.91,1.25,1.25,0,0,0-1-.73.72.72,0,0,0-.63.46,2.2,2.2,0,0,0-.13.57,3.5,3.5,0,0,0,.05,1,3.6,3.6,0,0,0,.73,1.56c.64.77,1.28.92,1.29.87s-.49-.35-1-1.09a3.46,3.46,0,0,1-.55-1.42,2.94,2.94,0,0,1,0-.89c0-.33.14-.6.27-.57s.42.22.56.48a5.22,5.22,0,0,1,.42.81,5.48,5.48,0,0,1,.37,1.52C452.24,466.47,452.1,467,452.19,467.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.2,456.75,488,483l-32.67-.14c.21-3.12,17.13-9.31,17.13-9.31l-.53-16.83Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.52,472.18a1.34,1.34,0,0,1,.92,1.53,1.28,1.28,0,0,1-1.51.92,1.4,1.4,0,0,1-1-1.62,1.32,1.32,0,0,1,1.67-.78",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488,483l0-2.65-31.4.86s-1.46.63-1.3,1.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.89,473.39c0,.16.8.23,1.58.75s1.2,1.19,1.34,1.13-.08-1-1-1.6S471.85,473.24,471.89,473.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.45,474.79c0,.16.66.43,1.19,1.11s.7,1.39.86,1.38.26-.91-.43-1.74S468.46,474.64,468.45,474.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.49,478.88c.14,0,.37-.76,0-1.63s-1.15-1.23-1.22-1.1.4.6.72,1.33S466.33,478.87,466.49,478.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.19,469.54c.07.14.8-.07,1.7,0s1.6.36,1.69.22-.59-.71-1.66-.77S472.11,469.41,472.19,469.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473,465.67a3.27,3.27,0,0,0,1.64,0,7.74,7.74,0,0,0,1.71-.52,7.94,7.94,0,0,0,.95-.5,1.76,1.76,0,0,0,.49-.38.7.7,0,0,0,.08-.85.9.9,0,0,0-.7-.37,1.82,1.82,0,0,0-.61.09,5.09,5.09,0,0,0-1,.34,5.63,5.63,0,0,0-1.51,1c-.77.7-1,1.3-1,1.33s.44-.45,1.21-1a6.31,6.31,0,0,1,1.47-.82,6.1,6.1,0,0,1,.94-.28c.34-.09.64-.09.73.06s0,.08,0,.18a1.43,1.43,0,0,1-.37.28,7.52,7.52,0,0,1-.86.49,9.15,9.15,0,0,1-1.59.6A11,11,0,0,0,473,465.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.19,465.9a2.58,2.58,0,0,0,.44-1.58,5.15,5.15,0,0,0-.22-1.79,5.27,5.27,0,0,0-.41-1,1.35,1.35,0,0,0-1-.83.77.77,0,0,0-.68.45,2.24,2.24,0,0,0-.18.6,3.68,3.68,0,0,0,0,1.1,3.78,3.78,0,0,0,.69,1.7c.64.85,1.3,1,1.31,1s-.5-.39-1-1.21a3.73,3.73,0,0,1-.51-1.54,3.32,3.32,0,0,1,0-.94c.05-.35.18-.63.31-.59s.44.26.57.53a6.37,6.37,0,0,1,.41.89,5.94,5.94,0,0,1,.31,1.64C473.28,465.27,473.1,465.87,473.19,465.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.28,308.67c-1.41.81-2.23,20.13,1.39,29.73s16.68,60.75,16.68,60.75L450,468.54l16.5-.91-5.86-149.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.41,317.73s6,42.38,9.89,59.34,5.3,22.6,5.3,22.6,6.66,13.32,6.68,13.66l5.8,54h17.49s4.6-47.35,2.1-56.8-6.4-23.91-5.56-34.47,1.11-33,1.11-34.85,4.46-14.62,4.46-14.62a36.06,36.06,0,0,0,1.78-12.78C492.18,306.55,443.41,317.73,443.41,317.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.28,412.23a1.08,1.08,0,0,1-.14-.21l-.37-.63c-.33-.61-.79-1.43-1.37-2.48l-5-9.15v0c-2.27-7.87-5.1-18.69-7.85-30.68-2.84-12.36-5.14-23.61-6.76-31.75-.78-4.05-1.42-7.33-1.87-9.66-.21-1.11-.37-2-.48-2.63,0-.28-.09-.5-.12-.69a.8.8,0,0,1,0-.23s0,.07.08.22.09.41.16.68l.57,2.61c.5,2.32,1.19,5.59,2,9.62,1.72,8.13,4.07,19.36,6.91,31.71,2.74,12,5.52,22.81,7.7,30.7v0c2,3.87,3.65,7,4.81,9.23.54,1.07,1,1.91,1.29,2.53l.32.66A.76.76,0,0,1,465.28,412.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.83,340.16a20.3,20.3,0,0,1-2.1-2.62,21.51,21.51,0,0,1-2.1-2.63,7.73,7.73,0,0,1,2.5,2.31A7.55,7.55,0,0,1,486.83,340.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.67,160.6c-.46-4-1.09-8.13-3.42-11.39a12.49,12.49,0,0,0-17.08-3.13l-2,1.26a50.72,50.72,0,0,0-2.53,15.26,14.75,14.75,0,0,0,3.19,8.57c.88,1.16,2.12,2.05,2.81,3.33a32.81,32.81,0,0,1,1.17,3.68c1.47,3.84,6.52,5.44,10.36,4s6.38-5.3,7.35-9.29S451.14,164.68,450.67,160.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.52,147c-4.41-1.22-7.11-2.83-7.09-4.57s7.67-5.85,9.43-6.91c4.18-2.5,9.17.67,16.52.76,14.28.19,25.83,3.24,25.78,6.83,0,1.72-2.73,3.26-7.14,4.36",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M433,146.92c-3.91-1.09-6.4-2.52-6.28-4,.33-4.27,10.34-5.62,23-5.45s22.89,2.87,22.84,6.05c0,1.53-2.42,2.89-6.32,3.87"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M466,146.07a17.5,17.5,0,0,0-18.16-17.36c-9.36.34-16.67,8.32-16.84,17.68-.15,8.22-.11,16.48.31,19.43,1.3,8.89,7,11.66,9.21,12.42a11,11,0,0,0,2.42.27h0s.06,0,.06.07l-.62,10.48c0,6.81,4.52,12.29,11.33,12.38s11.4-5.75,11.53-12.59Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.89,152.49a1.42,1.42,0,0,0,1.36,1.46,1.37,1.37,0,0,0,1.49-1.27,1.44,1.44,0,0,0-1.36-1.46A1.37,1.37,0,0,0,433.89,152.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.35,148.54c.17.19,1.26-.6,2.8-.58s2.65.81,2.82.62-.1-.42-.58-.78a4,4,0,0,0-2.26-.73,3.86,3.86,0,0,0-2.23.69C433.42,148.12,433.26,148.45,433.35,148.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.87,152.49a1.43,1.43,0,0,0,1.36,1.46,1.36,1.36,0,0,0,1.49-1.27,1.43,1.43,0,0,0-1.36-1.46A1.38,1.38,0,0,0,447.87,152.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.44,149c.17.19,1.27-.6,2.8-.57s2.65.8,2.82.62-.09-.42-.58-.79a3.88,3.88,0,0,0-2.25-.72,3.73,3.73,0,0,0-2.24.69C448.52,148.6,448.35,148.94,448.44,149Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.72,160.34a9.85,9.85,0,0,0-2.49-.48c-.39-.05-.76-.13-.83-.4a2,2,0,0,1,.28-1.16l1.2-3c1.66-4.23,2.88-7.71,2.71-7.78s-1.66,3.31-3.33,7.54c-.4,1-.79,2-1.15,3a2.21,2.21,0,0,0-.22,1.54,1,1,0,0,0,.63.58,2.47,2.47,0,0,0,.67.1A10.24,10.24,0,0,0,442.72,160.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,178.51s5.93.57,13.4-3.79c0,0-2.44,7.81-13.56,6.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.32,164.05a2.76,2.76,0,0,1,2.49-1,2.49,2.49,0,0,1,1.73,1,1.59,1.59,0,0,1,.1,1.83,1.87,1.87,0,0,1-2,.49,5.92,5.92,0,0,1-1.95-1.2,1.87,1.87,0,0,1-.43-.46.51.51,0,0,1,0-.57",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.22,161.46c-.25,0-.27,1.65-1.71,2.81s-3.22,1-3.24,1.19.4.33,1.15.36a4.07,4.07,0,0,0,2.69-.9,3.56,3.56,0,0,0,1.33-2.36C447.52,161.87,447.34,161.45,447.22,161.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.93,144.17c.14.42,1.68.25,3.48.49s3.25.75,3.49.38c.11-.18-.14-.58-.72-1a5.81,5.81,0,0,0-2.58-.94,6,6,0,0,0-2.73.28C448.2,143.65,447.87,144,447.93,144.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,144.59c.27.35,1.33,0,2.6,0s2.35.27,2.6-.1c.11-.17-.05-.52-.52-.86a3.67,3.67,0,0,0-2.11-.6,3.57,3.57,0,0,0-2.08.68C434,144.06,433.84,144.42,434,144.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.51,135.81a9.83,9.83,0,0,0,7.17,4.29c1.88.17,4-.14,5.43,1.13,1,.92,1.3,2.38,1.75,3.69.67,2,.59,4.44,2.4,5.49,1.42.83,2.56.58,3.58,1.87s1.25,3.34,1.25,5.07.12,4.47,1.67,5.25c.13-6.3,2.2-13.4,2.34-19.7a7.63,7.63,0,0,0-.29-2.78c-.74-2-3-3-5-3.54C457,134.92,451,134.65,445,134.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,140.8s3.9-15.15,4.23-15.89,4.74-7.33,15.12-9.1l8.56.11S467,120,469.21,123s2.94,17.37,2.94,17.37l-23.94-5.53-16.37,3.77Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.19,114.1l-2.37,0a2.41,2.41,0,0,0-2.24,1.43,7.46,7.46,0,0,0-.58,2.4c-.2,2.66-1,20.91-1,20.91l10.73-.35-.05-22.56,3.64.86,0-.66a2,2,0,0,0-.44-1.09h0a2,2,0,0,0-1.44-.71Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,142.36l1.19-5.27,16.85-5,20.09,6.21-.07,5.94A66.82,66.82,0,0,0,430,142.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.86,135.53l-.71.68-5.72,4.16a77.48,77.48,0,0,1,22.62-3.3c11.55.27,24.72,4.34,24.72,4.34l-7.6-4.7h0a13.22,13.22,0,0,0-9.32-4.3l-14.5-.47A13.2,13.2,0,0,0,432.86,135.53Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.08,140.6s.11-.12.36-.31a7.07,7.07,0,0,1,1.17-.72A20.71,20.71,0,0,1,434.4,138a53.67,53.67,0,0,1,16.54-.77c3.22.27,6.3.47,9.09.91a67.34,67.34,0,0,1,7.28,1.63,28.45,28.45,0,0,1,2.72.93,4.77,4.77,0,0,1,1.89,1.13,2,2,0,0,1,.53,1.3.8.8,0,0,1-.12.48,2,2,0,0,0-.59-1.61,4.81,4.81,0,0,0-1.83-1c-.79-.27-1.7-.56-2.72-.82-2-.52-4.51-1.07-7.25-1.49s-5.83-.58-9.05-.85a58.42,58.42,0,0,0-16.4.57,23,23,0,0,0-4.77,1.38C428.63,140.25,428.12,140.66,428.08,140.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.05,142.19c-1.16,4.82-6.91,12.44.88,17.34,0,0,.22-10.46,1.12-14.5a8.33,8.33,0,0,1,1.36-3.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.71,144.12a9.14,9.14,0,0,1,9.09,8.76,13.09,13.09,0,0,0,.09,3.65,24.57,24.57,0,0,0,1.7,3.15,17.07,17.07,0,0,1,1.46,8.19c-.84,5.58-6.28,13.29-12.53,13.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.12,176.32a4,4,0,0,1-3.7-.4A7.26,7.26,0,0,1,461,173a13,13,0,0,1,.17-12,19.09,19.09,0,0,1-3.55-17.7l8.91.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.38,139.43a2.51,2.51,0,0,0,.47-.24l1.31-.74,4.77-2.8h0v0l1.1-1.43a8.56,8.56,0,0,1,1.26-1.44,5,5,0,0,1,1.78-.93,8.86,8.86,0,0,1,2.16-.2c3-.06,6.36,0,9.85.18,3.25.13,6.36.31,9.2.5a6.46,6.46,0,0,1,2,.34,4.94,4.94,0,0,1,1.61,1c.86.91,1.64,1.86,2.38,2.68l0,0h0L470,139.1l1.55.73.55.23a2.87,2.87,0,0,0-.51-.3l-1.52-.8-5.61-2.86,0,0c-.73-.84-1.48-1.76-2.37-2.72a5.24,5.24,0,0,0-1.71-1.1,6.77,6.77,0,0,0-2.1-.37c-2.85-.21-6-.4-9.21-.53-3.5-.15-6.84-.23-9.88-.15a8.84,8.84,0,0,0-2.24.23,5.22,5.22,0,0,0-1.89,1,7.79,7.79,0,0,0-1.29,1.51l-1.08,1.44,0,0-4.71,2.9-1.27.8C426.52,139.31,426.37,139.41,426.38,139.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.69,131.81a2.7,2.7,0,0,0,.07-.75c0-.48,0-1.18.06-2,0-1.72,0-4.1,0-6.73,0-1.31,0-2.56,0-3.71q0-.84,0-1.62a.69.69,0,0,1,.74-.7l2,.4a2.61,2.61,0,0,0,.75.1,3.39,3.39,0,0,0-.71-.24c-.47-.13-1.13-.32-2-.53a1,1,0,0,0-1.09,1v1.62c0,1.15,0,2.4,0,3.71,0,2.63,0,5,.08,6.73,0,.86,0,1.56.06,2A2.9,2.9,0,0,0,453.69,131.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,131.46a10.53,10.53,0,0,0,.36-2.21c.15-1.38.26-3.3.36-5.4s.17-4,.2-5.41a13.4,13.4,0,0,0,0-2.24,13.51,13.51,0,0,0-.24,2.23c-.1,1.38-.21,3.29-.31,5.4s-.18,3.9-.25,5.39A15.6,15.6,0,0,0,443.31,131.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.75,146.38a3,3,0,0,1,2.54,2.1,18.85,18.85,0,0,1,.69,3.42,4.37,4.37,0,0,0,1.69,3c.86.53,2,.54,2.82,1.07a2.8,2.8,0,0,1,.84,3.82,4.75,4.75,0,0,1,.89,8.87c1.5,2.14.59,5.25-1.22,7.13a9.42,9.42,0,0,1-16.13-5.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.85,155.57c-.05,0-.06-.38-.29-1a4,4,0,0,0-1.72-2,11.08,11.08,0,0,0-3.88-1.23c-1.54-.26-3.27-.38-5.06-.83a8.72,8.72,0,0,1-2.52-1,11.52,11.52,0,0,1-1.93-1.61,28.13,28.13,0,0,1-2.67-3.25c-.69-1-1.23-1.77-1.6-2.32a4.07,4.07,0,0,1-.53-.89,28.13,28.13,0,0,1,2.43,3,32.54,32.54,0,0,0,2.71,3.13,11.19,11.19,0,0,0,1.86,1.52A8.41,8.41,0,0,0,466,150c1.72.43,3.45.57,5,.86a10.78,10.78,0,0,1,4,1.39,4.1,4.1,0,0,1,1.72,2.27A2.18,2.18,0,0,1,476.85,155.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.16,166.12c-.05,0-.1-.5-.4-1.35a8.3,8.3,0,0,0-2.12-3.1,14.7,14.7,0,0,0-4.78-2.92c-2-.8-4.27-1.4-6.59-2.37a17.31,17.31,0,0,1-5.82-4,29,29,0,0,1-3.54-4.53c-.89-1.37-1.54-2.52-2-3.31a7.34,7.34,0,0,1-.63-1.27,8,8,0,0,1,.8,1.16c.5.77,1.19,1.88,2.11,3.22a32.57,32.57,0,0,0,3.58,4.4,17.41,17.41,0,0,0,5.69,3.83c2.26.95,4.56,1.56,6.57,2.4a14.34,14.34,0,0,1,4.85,3.11,7.8,7.8,0,0,1,2.05,3.3,4.57,4.57,0,0,1,.2,1C482.17,166,482.18,166.12,482.16,166.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.53,155.44a6.82,6.82,0,0,1,.43-2.05,37.8,37.8,0,0,1,1.72-4.75,41.25,41.25,0,0,1,2.32-4.5,7.53,7.53,0,0,1,1.21-1.71c.13.08-1.49,2.82-3,6.41S426.68,155.48,426.53,155.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.29,203.7c-2.31,3.58-15.34,41.63-15.5,44.13s-.5,10.85,1.31,12.53,13.41,1,13.41,1l12-66.59v-.88S425.6,200.13,423.29,203.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.23,261.51c-3.32,0-7.15-.21-8.14-1.13-2-1.83-1.4-11.46-1.33-12.55.09-1.33,3.65-12.16,6.95-21.67s7.35-20.6,8.56-22.47h0c2.28-3.54,11.12-9.79,11.21-9.85l0,0v.93l-12,66.61h0C422.3,261.37,419.94,261.51,417.23,261.51Zm6.08-57.79c-1.2,1.86-5.21,12.82-8.55,22.46s-6.86,20.33-6.95,21.65c-.07,1.09-.65,10.7,1.31,12.51,1.75,1.62,12.83,1,13.37,1l12-66.57v-.83c-.65.46-9,6.4-11.16,9.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.46,186.44,440.14,209s21.93-18.56,25.11-22.25h0l9.26,1.82a23,23,0,0,1,17.84,16.34,37.75,37.75,0,0,1,1.42,10.05c0,12.12-2.38,80.65-2.38,80.65s2.38,21.85.2,28.4-2,5-2,5-15.1-4.57-21.65-4.77-22.63-.61-29.79-3.19-17.29-11.51-17.29-11.51l3.94-89.33a47.7,47.7,0,0,1,8.88-25.68h0Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.22,278.9s69.45,8.75,69.48,9.06-.29,7.06-.29,7.06l.4,5.1-70.22-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.61,270.06c.62-.14,46.47,2.23,51.34,4.22s18.09,3,18.09,3,.69-11.92.54-11.77-13.9,0-16.19-1-6.45-5.31-6.45-5.31l-46.73-2.81Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M468.24,196.29a8.63,8.63,0,0,1-.69,1.42c-.24.44-.53,1-.84,1.64s-.69,1.37-1,2.21c-.76,1.64-1.56,3.64-2.34,5.89a69.91,69.91,0,0,0-2.06,7.49,71.58,71.58,0,0,0-1.12,7.68c-.19,2.38-.26,4.53-.22,6.34s.1,3.27.18,4.28a7.89,7.89,0,0,1,.06,1.58,11.15,11.15,0,0,1-.26-1.56c-.15-1-.27-2.47-.35-4.29a59,59,0,0,1,.11-6.39,58.31,58.31,0,0,1,3.21-15.29,55.72,55.72,0,0,1,2.46-5.89c.38-.83.79-1.54,1.13-2.18s.65-1.18.92-1.61A8.46,8.46,0,0,1,468.24,196.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.07,188.89c.06.07-.94.9-2.38,2.38a36.15,36.15,0,0,0-4.93,6.39,35.75,35.75,0,0,0-3.34,7.36c-.64,2-.9,3.24-1,3.22a3.43,3.43,0,0,1,.09-.91,24.52,24.52,0,0,1,.54-2.42,30.74,30.74,0,0,1,8.37-13.9,20,20,0,0,1,1.88-1.61A3.84,3.84,0,0,1,469.07,188.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.14,245.86l7.82-2.79,6.73-4.9L456,242.33s16,0,16.63.68a1.37,1.37,0,0,1,0,2.11c-.65.66-13.46,1.74-13.46,1.74s14.45,1.14,14,1.59,0,1.93-2,2.25-10,1.25-10,1.25l11,.72s.49,1.55-2,2.09-9.91,1.69-9.91,1.69,10.24-1.15,10.08,0,.26,2.46-1.27,2.46-17,1.48-18.93,1.31-10.11,0-10.11,0l.44-14.08Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,260.24s17.83,5.73,22.26,5.24,8.17-1.15,10.41-9.33,5.62-18.74,5.62-18.74l-19.15-2.57-5.42,12.74-13.72.87Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.17,234.84s-.7-1.79,0-2.76a8.43,8.43,0,0,0,1.09-2.36s6.33-20.18,7.84-24.18,7.26-15.45,13.35-13.46,8.69,10.86,8.35,17.81-2.09,47.31-2.09,47.31l-15-1.05,5.62-18.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.73,257.23h0l-15-1.06,5.62-18.73-19.13-2.58h0s-.7-1.81,0-2.78a8.37,8.37,0,0,0,1.09-2.36c.06-.2,6.34-20.22,7.84-24.17a39,39,0,0,1,5-9,15.34,15.34,0,0,1,3.95-3.79,5.26,5.26,0,0,1,4.46-.7c3.54,1.15,5.55,4.47,6.61,7.05a26.11,26.11,0,0,1,1.76,10.78c-.34,6.88-2.07,46.91-2.09,47.31Zm-15-1.1,14.95,1c.06-1.21,1.75-40.47,2.09-47.28A26,26,0,0,0,488,199.13c-1.06-2.57-3.05-5.88-6.57-7a5.24,5.24,0,0,0-4.42.7,15.11,15.11,0,0,0-3.94,3.78,38.65,38.65,0,0,0-4.95,9c-1.5,4-7.78,24-7.84,24.18a9.18,9.18,0,0,1-1.1,2.37c-.66.9-.06,2.55,0,2.71l19.16,2.58v0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.26,188.39s-1.27,5,8.23,3.46,14.76-5.13,14.76-5.13l2.86.39-28,21.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.11,209V209l2.07-20.05a2.81,2.81,0,0,1,.05-.54h0l0,.53a2.77,2.77,0,0,0,.7,1.89c1.2,1.31,3.75,1.65,7.56,1,9.38-1.56,14.7-5.1,14.75-5.13h0l2.92.4-.05,0Zm2.08-19.77-2,19.66,27.88-21.8-2.79-.38c-.24.16-5.54,3.61-14.77,5.13-3.83.64-6.38.29-7.59-1A2.67,2.67,0,0,1,442.19,189.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.52,182.69c-.2.18,2.59,4.42,2.59,4.42l-21.85,16.76L444,196.14s-5.4,5.47-5.6,5.3,3.16-15,3.16-15l1-1.31,2.94,6.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.24,203.91v0L444,196.19c-.21.21-1.45,1.46-2.7,2.68-2.4,2.34-2.79,2.6-2.88,2.6h0s-.13-.12,1.5-7.59c.81-3.69,1.65-7.4,1.65-7.44h0l1-1.33,0,0,2.93,6.88,20.11-9.4-.12.11a31.2,31.2,0,0,0,2.6,4.38v0l0,0ZM444,196.1l0,0,2.24,7.69,21.81-16.73c-.1-.15-.75-1.13-1.36-2.12a9.63,9.63,0,0,1-1.24-2.25l-20,9.34v0l-2.93-6.86-1,1.27c-1.14,5-3.25,14.58-3.16,15a74,74,0,0,0,5.56-5.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.11,187.11a2.3,2.3,0,0,1-.37.32l-1.1.84-4.13,3c-3.49,2.52-8.34,6-13.71,9.76l-1.87,1.31-.4.28v-.48a28.06,28.06,0,0,0-.71-5.14,24.31,24.31,0,0,1-.6-4.71l.4.13-5.09,6.69L439.08,201a4.35,4.35,0,0,1-.55.63,3.63,3.63,0,0,1,.44-.71l1.35-1.92,4.94-6.79.38-.53,0,.65a25.58,25.58,0,0,0,.64,4.62,26.7,26.7,0,0,1,.74,5.22l-.41-.2,1.87-1.31c5.37-3.79,10.25-7.19,13.8-9.64l4.22-2.87,1.16-.76C468,187.17,468.1,187.09,468.11,187.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.15,230.83c0-.05.49.19.93.88a3.79,3.79,0,0,1-1.56,5.46c-.74.35-1.25.32-1.26.26s.46-.18,1.08-.58a3.77,3.77,0,0,0,1.42-5C480.44,231.22,480.09,230.89,480.15,230.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.56,226.19c0-.05.38.13.74.61a3.34,3.34,0,0,1,.61,2.25,3.3,3.3,0,0,1-1,2.1c-.44.41-.81.52-.84.46s.24-.28.57-.71a3.66,3.66,0,0,0,.78-1.9,3.7,3.7,0,0,0-.4-2C481.74,226.51,481.5,226.25,481.56,226.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,209.68a82.37,82.37,0,0,1-2.9,8.6,77.89,77.89,0,0,1-3.39,8.41,83.59,83.59,0,0,1,2.9-8.59A78.64,78.64,0,0,1,488,209.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.91,231.69a17.3,17.3,0,0,1-2.49-.59,40.36,40.36,0,0,0-6.06-1,41,41,0,0,0-6.15,0,18.78,18.78,0,0,1-2.56.16,9.49,9.49,0,0,1,2.53-.52,30,30,0,0,1,12.34,1.05A9.53,9.53,0,0,1,479.91,231.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,228.46c0,.16-3.4,0-7.55.38s-7.48,1-7.52.84a8.28,8.28,0,0,1,2.15-.61,44.82,44.82,0,0,1,5.33-.75,42.31,42.31,0,0,1,5.37-.11A8.53,8.53,0,0,1,479,228.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.14,245.86l7.82-2.79,6.83-5L456,242.33s16,0,16.63.68a1.37,1.37,0,0,1,0,2.11c-.65.66-13.46,1.74-13.46,1.74s14.45,1.14,14,1.59,0,1.93-2,2.25-10,1.25-10,1.25l11,.72s.49,1.55-2,2.09-9.91,1.69-9.91,1.69,10.24-1.15,10.08,0,.26,2.46-1.27,2.46-17,1.48-18.93,1.31-27.14,1-27.14,1l.87-19.69Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.14,245.86l-.33-.05-1-.2-3.77-.81-14.24-3.13.18-.15c-.22,5.5-.5,12.17-.81,19.7L423,261l13-.58,7.05-.28c2.41-.07,4.87-.21,7.4-.15,5-.16,10.18-.72,15.53-1.13l2-.15,1,0a.94.94,0,0,0,.74-.24c.32-.37.19-1.14.27-1.84,0-.08,0-.22,0-.13h0l-.06,0a1.69,1.69,0,0,0-.43-.11,7.71,7.71,0,0,0-1-.1,69.1,69.1,0,0,0-8.31.5l-.07-.52,3.28-.56,4.93-.84a15.27,15.27,0,0,0,2.37-.49,2.23,2.23,0,0,0,.89-.62,1.13,1.13,0,0,0,.2-.93l.23.18-11-.73,0-.5,7.15-.89,1.76-.22a7.75,7.75,0,0,0,1.67-.29,1.44,1.44,0,0,0,.89-1.13l.11-.43a1.63,1.63,0,0,1,.1-.25l.08-.12.05-.06s.07-.11,0,.05a.23.23,0,0,0,0,.18l0,0s0,0,0,0l-.07,0-.19-.05-.41-.08c-4.5-.65-8.93-1-13.14-1.34v-.46c3.2-.27,6.3-.57,9.26-.93.74-.09,1.47-.18,2.19-.3.36-.05.71-.12,1.06-.19a2.26,2.26,0,0,0,.89-.3,1.15,1.15,0,0,0,0-1.64c-.11-.2-.51-.2-.83-.26l-1-.1c-5.45-.35-10.41-.36-14.75-.42h-.23l.09-.22,1.8-4.22.22.17L451,243.15h0l-5.83,2-1.52.51c-.34.12-.51.16-.51.16l.51-.21,1.5-.56,5.78-2.12,0,0,6.8-5,.42-.31-.2.48c-.55,1.29-1.12,2.66-1.78,4.23l-.14-.22c4.34,0,9.29,0,14.77.34l1,.1.53.09.29.08a.93.93,0,0,1,.27.22,1.66,1.66,0,0,1,.43,1.1,1.72,1.72,0,0,1-.47,1.09,1.26,1.26,0,0,1-.57.3c-.18,0-.36.1-.54.13-.36.08-.72.14-1.09.2-.72.12-1.46.21-2.2.31-3,.37-6.06.68-9.27,1v-.46c4.22.36,8.62.67,13.19,1.32l.43.09.23.06.13,0,.1.06s0,0,.07.08a.27.27,0,0,1,0,.23c-.11.2-.08.11-.09.14l0,0a.61.61,0,0,1,0,.06s0,.1-.06.15l-.1.41a2.29,2.29,0,0,1-.39.88,2,2,0,0,1-.79.59,8.4,8.4,0,0,1-1.78.33l-1.76.22-7.17.89v-.51l11,.72.18,0,.05.16a1.65,1.65,0,0,1-.29,1.4,2.56,2.56,0,0,1-1.1.79,14.91,14.91,0,0,1-2.47.52l-4.94.85-3.29.56-.06-.52a67.51,67.51,0,0,1,8.38-.49,6.44,6.44,0,0,1,1.06.1,2.24,2.24,0,0,1,.57.16l.16.1a.8.8,0,0,1,.15.2.78.78,0,0,1,0,.38c0,.32,0,.65,0,1a1.8,1.8,0,0,1-.35,1.12,1.47,1.47,0,0,1-1.13.4l-1,.05-2,.15c-5.36.4-10.52.95-15.59,1.11-2.49-.06-4.95.07-7.36.13l-7,.26-13,.54h-.22v-.22c.35-7.53.66-14.2.92-19.69v-.18l.18,0,14.17,3.27,3.76.89,1,.24A1.54,1.54,0,0,1,443.14,245.86Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M459.76,230.93a39.77,39.77,0,0,1,1.42-17.19,117.86,117.86,0,0,1,6.34-16.17,25.58,25.58,0,0,0-6.67,10.25,66.3,66.3,0,0,0-3,12c-.77,4.41-1.36,9.32,1.12,13l1-2.12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.78,447.32l.1,35.88,44.64.11c-.25-4.26-23.33-12.88-23.33-12.88l.88-23Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.39,468.46a1.83,1.83,0,0,0-1.26,2.08,1.75,1.75,0,0,0,2.05,1.27,1.93,1.93,0,0,0,1.33-2.21,1.83,1.83,0,0,0-2.28-1.08",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.88,483.2v-3.62L313.76,481s2,.87,1.76,2.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.92,470.2c0,.22-1.1.32-2.17,1s-1.65,1.61-1.85,1.52.12-1.34,1.44-2.17S293,470,292.92,470.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.59,472.15c.05.21-.89.58-1.63,1.5s-1,1.9-1.18,1.89-.35-1.25.59-2.37S297.59,471.94,297.59,472.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.24,477.76c-.2.05-.5-1,.06-2.24s1.59-1.66,1.68-1.48-.54.82-1,1.81S300.46,477.74,300.24,477.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.54,464.94c-.1.2-1.09-.1-2.33,0s-2.19.46-2.3.28.81-1,2.26-1S292.64,464.77,292.54,464.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.49,459.64a4.15,4.15,0,0,1-2.24,0,10.12,10.12,0,0,1-2.34-.73,10.62,10.62,0,0,1-1.28-.68,3,3,0,0,1-.67-.53,1,1,0,0,1-.1-1.16,1.21,1.21,0,0,1,1-.5,2.85,2.85,0,0,1,.83.12,7.82,7.82,0,0,1,1.39.48A7.59,7.59,0,0,1,290.1,458c1,1,1.39,1.78,1.31,1.82s-.6-.61-1.65-1.41a9.66,9.66,0,0,0-2-1.13,8.3,8.3,0,0,0-1.28-.39c-.48-.13-.88-.13-1,.08s-.05.11.05.25a2.39,2.39,0,0,0,.49.38,13.16,13.16,0,0,0,1.18.68,12.21,12.21,0,0,0,2.16.83A15.36,15.36,0,0,1,291.49,459.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.2,460c-.08,0-.51-.74-.58-2.16a7.3,7.3,0,0,1,.88-3.8,1.82,1.82,0,0,1,1.43-1.12,1,1,0,0,1,.93.62,2.84,2.84,0,0,1,.23.82,5.09,5.09,0,0,1,0,1.51,5.23,5.23,0,0,1-1,2.3c-.88,1.16-1.79,1.42-1.81,1.34s.69-.52,1.36-1.63a5.06,5.06,0,0,0,.71-2.1,4.74,4.74,0,0,0,0-1.3c-.07-.47-.25-.85-.43-.81s-.6.36-.78.73a7.83,7.83,0,0,0-.56,1.22,8.27,8.27,0,0,0-.44,2.23C291.09,459.1,291.32,459.92,291.2,460Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,443l-5.21,35.49,44.13,6.72c.38-4.26-21.16-16.2-21.16-16.2l4.27-22.6Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211,465a1.82,1.82,0,0,0-1.56,1.86,1.77,1.77,0,0,0,1.84,1.57,1.93,1.93,0,0,0,1.64-2,1.81,1.81,0,0,0-2.09-1.41",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.35,478.5l.52-3.58,42.21,7.79s1.83,1.15,1.4,2.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.07,468.91c0,.21-1.13.15-2.3.68s-1.87,1.35-2.05,1.23.32-1.31,1.74-1.93S225.15,468.72,225.07,468.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.41,471.53c0,.21-1,.44-1.85,1.24s-1.22,1.73-1.44,1.69-.16-1.28.94-2.26S229.43,471.32,229.41,471.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.19,477.47c-.2,0-.34-1.11.4-2.21s1.81-1.41,1.87-1.21-.65.72-1.24,1.63S231.41,477.48,231.19,477.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.47,463.65c-.12.18-1.06-.27-2.29-.37s-2.24.14-2.33-.06,1-.84,2.4-.69S225.6,463.5,225.47,463.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.22,458.25a4.09,4.09,0,0,1-2.21-.35,10,10,0,0,1-2.21-1.06,11.19,11.19,0,0,1-1.16-.86,2.59,2.59,0,0,1-.59-.63,1,1,0,0,1,.07-1.16,1.22,1.22,0,0,1,1-.35,3.11,3.11,0,0,1,.81.24,8,8,0,0,1,3.14,2.33c.88,1.11,1.11,2,1,2s-.51-.7-1.43-1.64a8.88,8.88,0,0,0-1.8-1.41,7.51,7.51,0,0,0-1.21-.58c-.45-.2-.85-.26-1-.07s-.06.1,0,.25a2.3,2.3,0,0,0,.44.46,12.21,12.21,0,0,0,3.07,2A17,17,0,0,1,225.22,458.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.89,458.52a3.62,3.62,0,0,1-.26-2.23,7.24,7.24,0,0,1,1.44-3.63,1.86,1.86,0,0,1,1.58-.9,1,1,0,0,1,.83.76,2.9,2.9,0,0,1,.1.84,4.75,4.75,0,0,1-.23,1.49,5.08,5.08,0,0,1-1.29,2.14c-1,1-2,1.14-2,1.06s.76-.42,1.59-1.42a5.08,5.08,0,0,0,1-2,4.49,4.49,0,0,0,.16-1.28c0-.48-.12-.89-.3-.87s-.65.26-.89.61a8.58,8.58,0,0,0-.73,1.12,8.26,8.26,0,0,0-.76,2.14C224.9,457.66,225,458.5,224.89,458.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.08,353.17c.34-11-2.16-79.21-2.16-79.21l-75.59,1.33c.33,1-13.64,188.54-13.64,188.54l24.72,1.34L238.7,377.3s4.71-9,5-12.05c.39-4,11.3-57.48,11.3-57.48s4.38,30.2,8.13,64.62c4.43,40.67,5.43,86.8,6,91.05L296,463.1S293.75,364.19,294.08,353.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.47,284a15.71,15.71,0,0,1,.14,2.85c0,1.76,0,4.18,0,6.87,0,1.34,0,2.61-.13,3.79a8,8,0,0,1-.83,3,3.61,3.61,0,0,1-2.05,2,6.1,6.1,0,0,0,1.72-2.15,8.2,8.2,0,0,0,.68-2.92c.08-1.14.06-2.42.09-3.76,0-2.68.11-5.11.18-6.87A16.15,16.15,0,0,1,256.47,284Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.08,285.87a5.5,5.5,0,0,1-.18-.63,2.63,2.63,0,0,0-1-1.36,2.51,2.51,0,0,0-2.34-.31,2.46,2.46,0,1,0,2.34,4.28,2.61,2.61,0,0,0,1-1.35,5.5,5.5,0,0,1,.18-.63s.09.24,0,.68a2.65,2.65,0,0,1-1,1.6,2.85,2.85,0,0,1-2.74.46,2.9,2.9,0,1,1,2.74-5,2.65,2.65,0,0,1,1,1.6C254.17,285.63,254.11,285.87,254.08,285.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.54,289.33s-.25.08-.71.11a10.28,10.28,0,0,1-1.93-.06,15.48,15.48,0,0,1-10.79-6.29,9.61,9.61,0,0,1-1-1.66c-.2-.41-.29-.65-.26-.67s.55.85,1.55,2.11A17,17,0,0,0,290,289C291.53,289.27,292.54,289.24,292.54,289.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.78,373.77a3.48,3.48,0,0,1-.54.77c-.37.48-.92,1.15-1.62,2-1.41,1.63-3.42,3.82-5.75,6.13s-4.56,4.29-6.2,5.68c-.83.69-1.5,1.24-2,1.6a3.17,3.17,0,0,1-.78.53,26.68,26.68,0,0,1,2.51-2.41c1.58-1.45,3.75-3.47,6.08-5.77s4.37-4.45,5.84-6A26.71,26.71,0,0,1,240.78,373.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.14,159.76s5.53,2.31,7.61,13.18,6,79.79,6,79.79l-12.27.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.47 153.27 236.72 154.35 264.31 195.78 271.67 153.96 243.47 153.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.14,159.76c-5.32-2.4-19.47-5.8-19.47-5.8l-7.36,32.82-27.59-32.43s-18.85,2.4-22.14,4.67l.1.36L229,213.08a7.34,7.34,0,0,1-.73,6.19l-9.69,15.55-1.37,24.27-.92,16.2s30.84,6.79,38.55,7,38.1-6,38.1-6-1.64-87.24-1.61-93.59C291.41,176.13,291.14,159.76,291.14,159.76Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.31,240.43c2-1.16,73.87-7.66,73.87-7.66l.29,16.1-75.07,4.65.63-8.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292.58 254.8 292.87 270.48 216.51 272.05 217.25 259.09 292.58 254.8",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.4,215.38l4.22,19.44,10.16-16.3a5.82,5.82,0,0,0,.66-4.64l-7.07-25.39-8,26.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.58,159a14.18,14.18,0,0,0-3.79,3.84c-1.3,2.16-20.67,65.22-20.67,67.95s12.23,37.94,12.23,37.94L222,261.22l-8.7-32.31L224.17,195Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.56,229.69c-.12.09-1-1.11-2.56-2s-3-1.19-3-1.34a6.17,6.17,0,0,1,5.55,3.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.33,228.91a7.36,7.36,0,0,1,.39,1.26c.25.92.56,2.08.94,3.46.79,2.92,2,6.93,3.27,11.36s2.42,8.47,3.13,11.42c.35,1.48.62,2.68.77,3.51a7.19,7.19,0,0,1,.2,1.3,6.41,6.41,0,0,1-.4-1.26c-.24-.91-.56-2.07-.93-3.45-.79-2.92-2-6.94-3.27-11.37s-2.43-8.47-3.13-11.42c-.35-1.47-.62-2.67-.78-3.5A5.65,5.65,0,0,1,213.33,228.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,200a5.5,5.5,0,0,1-.08,1.21c-.08.77-.25,1.89-.51,3.26a78.41,78.41,0,0,1-2.89,10.49c-1.37,4-2.73,7.62-3.66,10.23l-1.11,3.1a5.29,5.29,0,0,1-.45,1.12,5,5,0,0,1,.26-1.18c.2-.75.53-1.83.95-3.15.84-2.66,2.15-6.27,3.52-10.28a102.8,102.8,0,0,0,3-10.41c.3-1.35.53-2.45.67-3.21A5.15,5.15,0,0,1,222,200Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.66,299.5a26.57,26.57,0,0,0,9.54-7.44.35.35,0,0,1,0-.29.46.46,0,0,1,.34-.14,45.38,45.38,0,0,0,3-3.94c-2.37-2.06-5.41-5.09-1.64-5.1,4.63,0,8.19-1.77,8.82-2.92s-.73-2.44-2-1.83a16.75,16.75,0,0,1-4.58.9,10.94,10.94,0,0,1-3.74-.28c-.76-.19-3.21-2.43-5.92-4.19a2.28,2.28,0,0,0-1.3-.36l-1.09-.23a3.45,3.45,0,0,1-2.56-2.23l-2.49-9.09-13.59,5.19,7.38,16.32S218.5,294,222.66,299.5Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.84,300.59a10.34,10.34,0,0,0,3.12-1,26.7,26.7,0,0,0,11.91-10.1,10.53,10.53,0,0,0,1.47-2.92c-.19-.13-2.43,4.42-7.11,8.34S219.74,300.38,219.84,300.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.86,282.76c-.14,0-.05-21.49.2-48s.57-48,.71-48,.06,21.49-.19,48S263,282.77,262.86,282.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.88,252.91v25L290,289.22s-9.26-1.21-11.2-6.88l7.33-7.15s-4,1.75-6.19,0-1.88-2.82-.13-2.29,5.11,0,6.18-.85a62.2,62.2,0,0,1,5.65-3.3h1.2l-.38-15.84Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.24,112.11c4.41-1.22,7.11-2.83,7.08-4.57s-7.66-5.85-9.43-6.91c-4.17-2.5-9.16.67-16.51.76-14.29.19-25.83,3.24-25.78,6.83,0,1.72,2.73,3.26,7.13,4.36",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.77,112c3.91-1.08,6.4-2.52,6.28-4-.33-4.27-10.34-5.62-23-5.45s-22.89,2.87-22.85,6c0,1.53,2.43,2.89,6.33,3.87"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.63,108.63a20.91,20.91,0,0,0-20.24-19.88l-1.08,0c-11.7.32-18,10.43-17.32,22.12L242.22,154a13.18,13.18,0,0,0,13.18,12.8h0a13.18,13.18,0,0,0,13.18-13.26c0-3.09,0-5.49,0-5.54s11.27-1.4,11.76-12.62C280.56,130,280.13,118.76,279.63,108.63Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.56,148a27.16,27.16,0,0,1-14.48-4.78s3.25,7.07,14.48,6.4Z",
    style: {
      fill: "#773f32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.87,117.93a1.6,1.6,0,0,1-1.59,1.57,1.53,1.53,0,0,1-1.61-1.5,1.61,1.61,0,0,1,1.59-1.57A1.53,1.53,0,0,1,275.87,117.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05,114.05c-.2.2-1.39-.74-3.12-.79s-3,.78-3.19.56.12-.47.69-.85a4.38,4.38,0,0,1,2.56-.7,4.19,4.19,0,0,1,2.48.88C277,113.57,277.15,114,277.05,114.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.07,117.86a1.61,1.61,0,0,1-1.6,1.57,1.53,1.53,0,0,1-1.6-1.5,1.6,1.6,0,0,1,1.59-1.57A1.53,1.53,0,0,1,259.07,117.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.09,113.84c-.21.2-1.39-.73-3.12-.78s-3,.77-3.19.56.12-.47.69-.86a4.38,4.38,0,0,1,2.56-.7,4.19,4.19,0,0,1,2.47.88C260,113.37,260.19,113.75,260.09,113.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,126.82a11.77,11.77,0,0,1,2.82-.41c.44,0,.86-.11.94-.41a2.16,2.16,0,0,0-.25-1.31l-1.2-3.4c-1.66-4.83-2.85-8.79-2.65-8.86s1.7,3.8,3.36,8.63l1.14,3.41a2.54,2.54,0,0,1,.17,1.74,1.09,1.09,0,0,1-.74.62,3,3,0,0,1-.75.08A10.91,10.91,0,0,1,266,126.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.84,127.86c.28,0,.22,1.86,1.79,3.24s3.56,1.24,3.56,1.5-.45.35-1.3.35a4.67,4.67,0,0,1-3-1.15,4.05,4.05,0,0,1-1.38-2.71C260.49,128.3,260.71,127.84,260.84,127.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.48,108.88c-.19.46-1.9.19-3.93.37s-3.69.68-3.94.25c-.12-.2.18-.63.86-1.07a6.57,6.57,0,0,1,2.94-.93,6.65,6.65,0,0,1,3,.46C260.19,108.28,260.56,108.66,260.48,108.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.73,109.75c-.31.38-1.49-.06-2.92-.13s-2.64.18-2.91-.23c-.11-.21.09-.59.63-1a4.05,4.05,0,0,1,2.39-.57,4.19,4.19,0,0,1,2.31.86C276.72,109.15,276.87,109.56,276.73,109.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.4,117.82c-.19-.09-7.64-2.52-7.63,5.16s7.71,6.09,7.72,5.87S243.4,117.82,243.4,117.82Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.15,125.94s-.14.09-.36.2a1.34,1.34,0,0,1-1,0c-.82-.3-1.5-1.59-1.54-3a4.42,4.42,0,0,1,.38-1.92,1.51,1.51,0,0,1,1-1,.67.67,0,0,1,.79.36c.1.22.05.37.1.38s.16-.13.1-.44a.82.82,0,0,0-.3-.48,1,1,0,0,0-.74-.2,1.87,1.87,0,0,0-1.4,1.19,4.4,4.4,0,0,0-.46,2.14c.05,1.55.84,3,1.95,3.32a1.43,1.43,0,0,0,1.22-.2C241.13,126.13,241.17,126,241.15,125.94Z",
    style: {
      fill: "#773f32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.75,105.9s-3.9-15.15-4.23-15.89-4.75-7.33-15.13-9.1l-8.56.11s-12.1,4.07-14.28,7.06-2.94,17.37-2.94,17.37l23.93-5.53,16.38,3.77Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.57,79.2l2.36,0a2.41,2.41,0,0,1,2.25,1.43,7.22,7.22,0,0,1,.57,2.4c.21,2.66,1.05,20.91,1.05,20.91l-10.74-.35L257.11,81l-3.63.86.05-.66a1.91,1.91,0,0,1,.44-1.09h0a2,2,0,0,1,1.44-.71Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.82,108.17l-.27-6-16.85-5-21.76,7.61v5.43A69.45,69.45,0,0,1,279.82,108.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.89,100.63l.72.68,5.72,4.16a77.48,77.48,0,0,0-22.62-3.3c-7.55.18-15.78,2.22-20.58,3.45-2.54.65-4.14.89-4.14.89l7.59-4.7h0a13.22,13.22,0,0,1,9.32-4.3L268.41,97A13.17,13.17,0,0,1,277.89,100.63Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.68,105.7s-.11-.12-.36-.31a6.83,6.83,0,0,0-1.18-.72,20.44,20.44,0,0,0-4.78-1.59,53.75,53.75,0,0,0-16.55-.77c-3.21.27-6.29.47-9.08.91a66.27,66.27,0,0,0-7.28,1.63,27.52,27.52,0,0,0-2.72.93,4.77,4.77,0,0,0-1.89,1.13,2,2,0,0,0-.53,1.3.8.8,0,0,0,.12.48,2,2,0,0,1,.59-1.61,4.81,4.81,0,0,1,1.83-1c.79-.27,1.7-.56,2.72-.82,2-.51,4.51-1.07,7.25-1.49s5.82-.58,9.05-.85a58.43,58.43,0,0,1,16.4.57A23.15,23.15,0,0,1,281,104.9C282.12,105.35,282.64,105.76,282.68,105.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.38,104.53a2.51,2.51,0,0,1-.47-.24l-1.31-.74-4.78-2.8h0v0c-.36-.46-.72-.94-1.1-1.44a8.56,8.56,0,0,0-1.26-1.44,5.09,5.09,0,0,0-1.79-.93,8.73,8.73,0,0,0-2.15-.2c-3-.06-6.36,0-9.85.18-3.25.13-6.36.31-9.21.5a6.45,6.45,0,0,0-2,.34,4.94,4.94,0,0,0-1.61,1c-.86.92-1.65,1.86-2.38,2.68l0,0h0l-5.66,2.75-1.55.73a3.87,3.87,0,0,1-.56.23,4.12,4.12,0,0,1,.52-.3l1.52-.8,5.61-2.86-.05,0c.74-.84,1.48-1.76,2.37-2.72a5.28,5.28,0,0,1,1.72-1.1,6.77,6.77,0,0,1,2.1-.37c2.85-.21,6-.4,9.21-.53,3.5-.15,6.84-.23,9.88-.15a8.88,8.88,0,0,1,2.24.23,5.22,5.22,0,0,1,1.89,1,8.15,8.15,0,0,1,1.29,1.51l1.08,1.44,0,0,4.72,2.9,1.27.8A3.06,3.06,0,0,1,284.38,104.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.07,96.91a2.7,2.7,0,0,1-.07-.75c0-.48,0-1.18-.06-2,0-1.72,0-4.1,0-6.73,0-1.31,0-2.56,0-3.71,0-.56,0-1.1,0-1.62a.68.68,0,0,0-.74-.7l-2,.4a2.61,2.61,0,0,1-.75.1,3.12,3.12,0,0,1,.71-.24c.47-.13,1.12-.32,2-.53a1,1,0,0,1,1.09,1v1.62c0,1.15,0,2.4,0,3.71,0,2.63,0,5-.08,6.73,0,.86,0,1.56-.07,2A3.29,3.29,0,0,1,257.07,96.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.45,96.56a10.53,10.53,0,0,1-.36-2.21c-.15-1.38-.26-3.29-.36-5.4s-.17-4-.2-5.41a12.17,12.17,0,0,1,0-2.24,13.51,13.51,0,0,1,.24,2.23c.1,1.38.21,3.29.31,5.4s.18,3.9.25,5.39A15.6,15.6,0,0,1,267.45,96.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.54,454.51l.55,27.9-34.71.86c.12-3.32,17.91-10.42,17.91-10.42L331.21,455Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343,471.08a1.42,1.42,0,0,1,1,1.59,1.37,1.37,0,0,1-1.57,1,1.5,1.5,0,0,1-1.07-1.7,1.41,1.41,0,0,1,1.75-.88",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.09,482.41l-.06-2.82-33.32,1.89s-1.53.71-1.33,1.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.73,472.69c0,.17.86.22,1.7.75s1.31,1.22,1.47,1.15-.13-1-1.16-1.66S331.69,472.53,331.73,472.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.12,474.28c0,.17.71.44,1.3,1.14s.78,1.46.95,1.45.25-1-.5-1.84S328.12,474.12,328.12,474.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.16,478.69c.16,0,.37-.82-.08-1.74s-1.26-1.26-1.33-1.12.43.63.8,1.39S326,478.68,326.16,478.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.93,468.59c.08.15.85-.1,1.81-.06s1.71.33,1.79.18-.64-.74-1.77-.77S331.84,468.46,331.93,468.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.65,464.45a3.26,3.26,0,0,0,1.74-.05,8.49,8.49,0,0,0,1.81-.6,9,9,0,0,0,1-.56,2.08,2.08,0,0,0,.52-.42.74.74,0,0,0,.05-.9.9.9,0,0,0-.75-.37,2.06,2.06,0,0,0-.65.1,6.77,6.77,0,0,0-1.07.4,6.06,6.06,0,0,0-1.58,1.09c-.79.77-1,1.41-1,1.44s.46-.49,1.27-1.12a6.94,6.94,0,0,1,1.52-.92,7.18,7.18,0,0,1,1-.33c.37-.1.68-.11.78.05s0,.08,0,.19a1.81,1.81,0,0,1-.38.31,8.81,8.81,0,0,1-.91.55,9.72,9.72,0,0,1-1.66.68A14,14,0,0,0,332.65,464.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.88,464.69a2.82,2.82,0,0,0,.42-1.69,5.75,5.75,0,0,0-.29-1.9,5.31,5.31,0,0,0-.47-1,1.43,1.43,0,0,0-1.13-.85.8.8,0,0,0-.71.5,2.14,2.14,0,0,0-.16.64,3.8,3.8,0,0,0,0,1.17,4,4,0,0,0,.79,1.78c.7.88,1.41,1.07,1.43,1s-.55-.4-1.09-1.25a4.08,4.08,0,0,1-.59-1.62,3.81,3.81,0,0,1,0-1c0-.37.17-.67.31-.63s.48.26.63.55a6.6,6.6,0,0,1,.45.93,6.46,6.46,0,0,1,.38,1.73C333,464,332.79,464.67,332.88,464.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.9,455.34l-.55,27.9,34.7.86c-.12-3.32-17.91-10.42-17.91-10.42l1.09-17.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.45,471.91a1.41,1.41,0,0,0-1,1.59,1.36,1.36,0,0,0,1.57,1,1.49,1.49,0,0,0,1.07-1.69,1.4,1.4,0,0,0-1.75-.88",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.35,483.24l0-2.82,33.33,1.89s1.52.71,1.32,1.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,473.51c0,.17-.86.23-1.71.75s-1.31,1.23-1.46,1.16.12-1.05,1.16-1.66S386.75,473.36,386.71,473.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.31,475.11c0,.17-.7.44-1.3,1.14s-.78,1.45-.95,1.44-.25-1,.51-1.83S390.31,475,390.31,475.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.27,479.52c-.15,0-.37-.82.09-1.74s1.26-1.27,1.33-1.12-.44.62-.8,1.38S392.44,479.51,392.27,479.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.51,469.42c-.08.15-.85-.1-1.81-.06s-1.71.32-1.8.17.65-.73,1.78-.76S386.59,469.29,386.51,469.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.78,465.28a3.25,3.25,0,0,1-1.74,0,8,8,0,0,1-1.8-.61,8.16,8.16,0,0,1-1-.55,2.56,2.56,0,0,1-.51-.42.76.76,0,0,1-.06-.91,1,1,0,0,1,.76-.37,2.45,2.45,0,0,1,.65.11,5.91,5.91,0,0,1,1.07.4,6.17,6.17,0,0,1,1.57,1.09c.79.76,1,1.4,1,1.44s-.46-.49-1.26-1.13a7.45,7.45,0,0,0-1.53-.91,7.18,7.18,0,0,0-1-.33c-.36-.11-.68-.12-.77,0s-.05.09,0,.2a1.86,1.86,0,0,0,.38.31,8.7,8.7,0,0,0,.9.55,9.79,9.79,0,0,0,1.67.68A11.47,11.47,0,0,1,385.78,465.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.55,465.52a2.81,2.81,0,0,1-.41-1.69,5.68,5.68,0,0,1,.28-1.9,6.05,6.05,0,0,1,.47-1.05A1.45,1.45,0,0,1,387,460a.84.84,0,0,1,.72.51,2.4,2.4,0,0,1,.16.64,4.13,4.13,0,0,1,0,1.17,4,4,0,0,1-.79,1.78c-.7.88-1.41,1.06-1.42,1s.54-.4,1.08-1.25a3.94,3.94,0,0,0,.59-1.62,3.42,3.42,0,0,0,0-1c-.05-.37-.18-.67-.32-.64s-.47.27-.62.56a5,5,0,0,0-.45.93,5.77,5.77,0,0,0-.38,1.73C385.48,464.85,385.65,465.49,385.55,465.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.26,315.84S317,385,316.6,388.06s2.26,10.58,2.26,10.58.88,15,0,19,.39,13.66.39,13.66,7.31,19.76,8.28,26.37a129.75,129.75,0,0,1,1.1,14.18H350.2l5.29-80.67,4.84-37.9,7.06,118.57s23.82.63,22.49.19,1.47-12.09,1.47-12.09l6-11.9s10.07-124.78,9.7-130.51c-.26-4.22-45.79-2.69-69.8-1.59C328.66,316.31,310.26,315.84,310.26,315.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.4 324.91 407.4 321.05 332.54 318.84 331.49 324.91 407.4 324.91",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.94,368.38a8.13,8.13,0,0,0,8.88-8l.6-35.1.12-6.48-22.84-.71v10.05l-2.11-.24L305,337.76l-5.14,1.17-.7,17.43s6.86,8.37,9.43,9.89C310,367.05,317,367.84,322.94,368.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.9,213.37s-2.37-7.84-3.43-9.84-5.71-8.41-5.71-8.41l-32.28-14.33a19.13,19.13,0,0,1-16.09,7c-5.55-.24-8.84-7.07-8.84-7.07l-29.23,2a20.38,20.38,0,0,0-11.66,4.37c-10.13,8-31,25.09-31,25.09l-14.11-6.55s-9.53,6.95-9.33,7.55,4.57,20.26,12.51,25,13.11,5.36,21.25,0c7-4.58,21.27-15.08,15.68-16.25-6.54,38.37-13.65,77.42-4.32,96.23L412,321.05l-.85-84.64L433.88,238Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.9,213.37s.22.53.62,1.59,1,2.65,1.74,4.73C428.8,223.85,431.05,230,434,238l0,.15h-.16l-22.75-1.55.15-.14c.24,21.8.56,50.75.93,84.64v.22H412l-103.65-2.85h-.15l-.07-.14a46.85,46.85,0,0,1-4-15.49,117.23,117.23,0,0,1-.39-16.36,317.64,317.64,0,0,1,3.54-33.35c1.59-10.56,3.4-21,5.15-31.18l0-.28.26.07a1.83,1.83,0,0,1,1.36.91,2,2,0,0,1-.19,1.61,10.11,10.11,0,0,1-1.76,2.4,43.07,43.07,0,0,1-4.28,3.95c-3,2.45-6.08,4.7-9.23,6.84s-6.47,4.2-10.3,4.71a13.94,13.94,0,0,1-5.64-.43,25.45,25.45,0,0,1-5.15-2.18c-.42-.22-.81-.45-1.21-.68a9.05,9.05,0,0,1-1.18-.75c-.37-.29-.77-.54-1.12-.85l-1-1a8.27,8.27,0,0,1-.9-1.06c-.28-.37-.6-.71-.84-1.1-.5-.77-1-1.51-1.46-2.32a58,58,0,0,1-4.34-9.92c-.58-1.7-1.1-3.4-1.58-5.1l-.69-2.56-.16-.64-.08-.32a.49.49,0,0,1,0-.23l.06-.11c0-.07.08-.1.12-.16a9.36,9.36,0,0,1,1-.93c2.69-2.28,5.49-4.32,8.25-6.36l.11-.09.13.06,14.1,6.56-.24,0L304,197.81l8.39-6.78,4.09-3.31a23.14,23.14,0,0,1,4.29-2.94,20.79,20.79,0,0,1,4.81-1.77,28.44,28.44,0,0,1,5-.6l9.69-.66,18.24-1.25h.11l.06.11a14.76,14.76,0,0,0,5.29,5.92c2.24,1.39,5,1.13,7.38.85a18.83,18.83,0,0,0,12-6.68l.08-.09.1,0L415.79,195h0v0c2,2.76,3.71,5.2,5.08,7.37a14.86,14.86,0,0,1,1.51,3.21c.37,1,.68,1.93.95,2.75.54,1.64.92,2.88,1.17,3.71s.36,1.26.36,1.26c-.1-.31-.57-1.75-1.62-4.94-.28-.82-.6-1.73-1-2.74a14.71,14.71,0,0,0-1.52-3.17c-1.38-2.16-3.12-4.59-5.11-7.34l0,0-32.3-14.28.18-.05a19.17,19.17,0,0,1-12.17,6.83c-.62.09-1.26.12-1.89.19s-1.28,0-1.93,0a7.91,7.91,0,0,1-3.79-1.09,15,15,0,0,1-5.43-6.07l.17.1-18.23,1.28-9.7.68a27.11,27.11,0,0,0-4.91.6,19.8,19.8,0,0,0-4.71,1.74,22.8,22.8,0,0,0-4.23,2.89l-4.08,3.32-8.38,6.78-17.52,14.2-.11.09-.13-.06-14.11-6.55.24,0c-2.75,2-5.55,4.1-8.21,6.34a11.1,11.1,0,0,0-.92.88.59.59,0,0,0-.08.11l0,0s-.1-.09-.17,0,.32-.1.16,0v.06l0,.08,0,.17.17.64c.22.85.45,1.7.68,2.55.48,1.69,1,3.39,1.58,5.07a57.8,57.8,0,0,0,4.3,9.83c.42.8.95,1.53,1.44,2.29.24.38.55.71.82,1.07a9.66,9.66,0,0,0,.87,1,15.1,15.1,0,0,0,4.38,3.16,24.4,24.4,0,0,0,5.05,2.14,13.51,13.51,0,0,0,5.44.42c3.68-.49,7-2.52,10.07-4.63s6.23-4.38,9.19-6.82a42.21,42.21,0,0,0,4.23-3.9,9.84,9.84,0,0,0,1.67-2.27,1.48,1.48,0,0,0,.18-1.18,1.37,1.37,0,0,0-1-.62l.31-.21c-1.74,10.24-3.55,20.63-5.14,31.17a317.56,317.56,0,0,0-3.54,33.3,114.49,114.49,0,0,0,.38,16.28,46.29,46.29,0,0,0,3.95,15.33l-.22-.15L412,320.83l-.22.22c-.31-33.88-.58-62.84-.78-84.64v-.15h.15l22.74,1.62-.1.14-6.62-18.31c-.75-2.08-1.31-3.66-1.7-4.74S424.9,213.37,424.9,213.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.24,180.68c-.89,0-30.11.69-30.11.69S322,203.17,322,207.06c0,2.56-8.23,33.47-16.94,63.58-5.19,18,1,50.41,1,50.41l32.41,0,4.78-30.4,12.69-89.91s-1.69-8.59-.75-13.9S357.24,180.68,357.24,180.68Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303,289.05q0,4.74.31,9.46l38.45-1.61.81-7.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.57,195.19l-29.33-14.45-7.15,15.17s-10.24,22.16-11.27,44-2.63,81.19-2.63,81.19l48.35.83-8.87-107.5S414.53,197.78,415.57,195.19Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.16,187.11s-2.62,4.11-3.21,6.89-2.58,21.05-3.58,51.05-1,31.7-1,31.7l8,.31s-1.78-55.06-.21-60.42,8.25-25.48,8.25-25.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387.45,207.44c-.09,0,.4-1.29.9-3.38a36.08,36.08,0,0,0,1-8.33,52.45,52.45,0,0,0-.7-8.37c-.34-2.13-.62-3.44-.54-3.46a3.7,3.7,0,0,1,.31.89c.17.58.38,1.44.6,2.5a42.76,42.76,0,0,1,.85,8.45,31.41,31.41,0,0,1-1.13,8.41,19.42,19.42,0,0,1-.84,2.44A3.62,3.62,0,0,1,387.45,207.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.7,203.37a56.51,56.51,0,0,1,10.51-22.58l-10.51.29a26.83,26.83,0,0,0-9.5,19.27l3.7,1.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.11,329.49a3.62,3.62,0,0,1-.87.41c-.57.24-1.4.56-2.44.93a28.84,28.84,0,0,1-8.44,1.8,14.61,14.61,0,0,1-8.35-2.11,9.4,9.4,0,0,1-2-1.7,3.16,3.16,0,0,1-.57-.78,19.59,19.59,0,0,0,2.77,2.17,15.24,15.24,0,0,0,8.14,1.9,33.58,33.58,0,0,0,8.35-1.63A26,26,0,0,1,330.11,329.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,346.92s-.19.28-.76.38a2.59,2.59,0,0,1-2.16-.81,5.92,5.92,0,0,1-1.24-3.19c-.2-1.27-.41-2.63-.64-4.06-.43-2.88-.8-5.49-1-7.38a19,19,0,0,1-.29-3.08,17.48,17.48,0,0,1,.65,3c.33,1.88.76,4.48,1.2,7.36.21,1.43.41,2.8.6,4.06a5.87,5.87,0,0,0,1,3,2.5,2.5,0,0,0,1.87.86A5.21,5.21,0,0,0,363,346.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.25,329.5a2.68,2.68,0,0,0-1.09,1.49,2.22,2.22,0,0,0,.34,1.85A2,2,0,0,0,365,331.6,2.18,2.18,0,0,0,364,330a2.69,2.69,0,0,0-1.78-.46s.15-.15.51-.2a2.28,2.28,0,0,1,1.48.35,2.52,2.52,0,0,1,1.19,1.93,2.48,2.48,0,0,1-4.31,1.55,2.48,2.48,0,0,1-.31-2.24,2.23,2.23,0,0,1,.91-1.22C362,329.48,362.24,329.48,362.25,329.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.92,332.31a2.69,2.69,0,0,1-.62.63,10.14,10.14,0,0,1-2,1.29A11.71,11.71,0,0,1,388.8,331a10,10,0,0,1-1.28-2,2.41,2.41,0,0,1-.3-.83,27.81,27.81,0,0,0,1.86,2.63,11.93,11.93,0,0,0,14,3.13A27.71,27.71,0,0,0,405.92,332.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,427.76c-.12.08-4.72-6.72-10.27-15.19s-10-15.39-9.85-15.47,4.72,6.72,10.28,15.19S341.13,427.68,341,427.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.39,386.23a4.75,4.75,0,0,1-.57,1c-.38.63-1,1.52-1.73,2.61-1.51,2.17-3.71,5.09-6.33,8.16s-5.17,5.7-7.08,7.53c-.95.92-1.74,1.64-2.3,2.12a5.6,5.6,0,0,1-.9.72,4.63,4.63,0,0,1,.76-.86l2.18-2.24c1.84-1.89,4.33-4.55,6.94-7.61s4.85-5.93,6.43-8l1.87-2.5A4.91,4.91,0,0,1,396.39,386.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.66,324.91a5.87,5.87,0,0,1-1.09.08l-3.08.07.15-.13c-.24,2.22-.23,5.27-.26,8.87s-.09,7.74-.14,12.13c-.08,3.49,0,6.79-.25,9.82a17.31,17.31,0,0,1-2.15,7.74,10,10,0,0,1-3.87,3.79,7.49,7.49,0,0,1-1.37.54,2,2,0,0,1-.51.1,18.58,18.58,0,0,0,1.78-.82,10.11,10.11,0,0,0,3.65-3.8,17.4,17.4,0,0,0,2-7.58c.18-3,.12-6.32.2-9.79.08-4.39.14-8.52.21-12.13a85.88,85.88,0,0,1,.42-8.9l0-.13h.12l3.08.07A6.68,6.68,0,0,1,334.66,324.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.38,142.47c-4.72-1.3-7.61-3-7.59-4.89s8.21-6.26,10.1-7.4c4.48-2.68,9.82.71,17.7.81,15.3.2,27.66,3.48,27.61,7.31,0,1.85-2.93,3.5-7.65,4.68",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350,142.37c-4.19-1.16-6.86-2.69-6.73-4.33.36-4.58,11.07-6,24.63-5.84s24.52,3.08,24.48,6.48c0,1.64-2.6,3.09-6.78,4.14"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M347.72,143.13A4.92,4.92,0,0,1,344.5,140c-.47-1.49.42-3.18,1.39-4.41a8.07,8.07,0,0,0,1.05-2.07c.74-1.71-.59-3.68-.26-5.52s1.95-2.84,3.57-3.45,3.39-1,4.78-2,2.13-2.37,3.34-3.4a6.94,6.94,0,0,1,6.27-1.36c2.21.63,4.05,2.34,6.32,2.59,1.66.19,3.29-.43,5-.53a8.31,8.31,0,0,1,8.32,6.2,9.87,9.87,0,0,0,1.78,4.31c1.36,1.69,3.7,2.24,4.76,4.12a4.87,4.87,0,0,1,.06,3.75,12.63,12.63,0,0,0-.9,3.73,4.56,4.56,0,0,0,3.55,4.27,4.54,4.54,0,0,1-2.35,2.81,5.19,5.19,0,0,0,2.78.65,9.2,9.2,0,0,1-12.22,5.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.2,151.29c.18-.08,7.33-2.31,7.23,5S384,162,384,161.83,384.2,151.29,384.2,151.29Z",
    style: {
      fill: "#f8ad91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.25,159.08s.12.1.34.2a1.26,1.26,0,0,0,1,0,3.17,3.17,0,0,0,1.51-2.82,4.15,4.15,0,0,0-.33-1.83,1.48,1.48,0,0,0-1-1,.64.64,0,0,0-.76.34c-.1.2-.06.35-.1.36s-.15-.12-.09-.43a.79.79,0,0,1,.3-.45,1,1,0,0,1,.71-.18,1.83,1.83,0,0,1,1.32,1.16,4.4,4.4,0,0,1,.41,2c-.07,1.48-.85,2.86-1.91,3.15a1.39,1.39,0,0,1-1.17-.21C386.26,159.26,386.22,159.1,386.25,159.08Z",
    style: {
      fill: "#ce8679"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.66,122l-1,0A20,20,0,0,0,348,140.71c-.61,9.68-1,20.38-1,25.57,0,11.67,11.09,12.21,11.09,12.21h0a12.21,12.21,0,0,0,12.21,12.23h1.57A12.23,12.23,0,0,0,384.1,178.8l.83-35.48C385.7,132.16,379.84,122.41,368.66,122Z",
    style: {
      fill: "#f8ad91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.39,178.5A25.3,25.3,0,0,0,371,174.87a.31.31,0,0,1,.42.42c-1.26,2-4.79,6-12.42,5.78a.94.94,0,0,1-.89-.9l0-1.36A.29.29,0,0,1,358.39,178.5Z",
    style: {
      fill: "#ce8679"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.77,149.58a1.54,1.54,0,0,0,1.51,1.52,1.48,1.48,0,0,0,1.56-1.41,1.54,1.54,0,0,0-1.51-1.52A1.48,1.48,0,0,0,351.77,149.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.36,148.93a1.54,1.54,0,0,0,1.51,1.52,1.46,1.46,0,0,0,1.55-1.41,1.53,1.53,0,0,0-1.5-1.53A1.48,1.48,0,0,0,368.36,148.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.31,146.4c.2.19,1.34-.69,3-.71s2.88.78,3.05.57-.11-.45-.65-.82a4.21,4.21,0,0,0-2.44-.71,4.06,4.06,0,0,0-2.38.82C350.38,145.94,350.22,146.31,350.31,146.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.9,145.73c.2.18,1.29-.77,2.94-.9s2.91.6,3.08.38-.14-.44-.7-.78a4.19,4.19,0,0,0-2.49-.55,4.06,4.06,0,0,0-2.32,1C366.94,145.27,366.8,145.64,366.9,145.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.86,158.29a11.65,11.65,0,0,0-2.69-.44c-.42,0-.83-.11-.9-.4a2.06,2.06,0,0,1,.26-1.25c.38-1,.77-2.1,1.19-3.23,1.65-4.6,2.83-8.37,2.65-8.44s-1.68,3.61-3.32,8.21c-.4,1.13-.78,2.21-1.14,3.25a2.41,2.41,0,0,0-.19,1.65,1.05,1.05,0,0,0,.7.61,2.4,2.4,0,0,0,.72.08A11.24,11.24,0,0,0,360.86,158.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.73,159.35c-.27,0-.24,1.78-1.75,3.07s-3.42,1.14-3.43,1.39.43.34,1.24.35a4.44,4.44,0,0,0,2.86-1.06,3.83,3.83,0,0,0,1.35-2.58C366.06,159.77,365.85,159.33,365.73,159.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.16,138.74c.21.43,1.83,0,3.78.09s3.56.4,3.77,0c.1-.2-.22-.59-.89-1a6.55,6.55,0,0,0-5.75-.05C366.39,138.15,366.07,138.53,366.16,138.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.55,142c.29.37,1.42,0,2.79-.09s2.53.21,2.79-.19c.11-.19-.08-.56-.59-.91a4.07,4.07,0,0,0-4.5.22C350.57,141.4,350.41,141.78,350.55,142Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.74,121.11c3.74-1.63,7.61-1,11.66-.53a18.49,18.49,0,0,1,8.71,3.1c4.18,2.87,6.37,7.59,6.77,12.65a47.19,47.19,0,0,1-1.06,14.51l-.4-.07a7,7,0,0,1,.19,3.73,2.42,2.42,0,0,1-2.9,1.72c-1.37-.54-1.49-2.4-1.42-3.88a105.77,105.77,0,0,0-.47-14.89c-.35-3.7-2.62-8.16-5.58-9.82-6.64-3.68-11.54,0-13.78.91-3.67-2.93-7.6-1-9.68,1.69C352.43,126.2,356,122.74,359.74,121.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.16,132.92c0,.23-.42.51-1.3.65a8.78,8.78,0,0,1-3.68-.42,19.4,19.4,0,0,1-4.77-2.37c-1.63-1.06-3.26-2.29-5-3.27a11,11,0,0,0-5-1.62,10.39,10.39,0,0,0-4.25.73c-2.38.92-3.6,2.24-4,1.93-.1-.07-.13-.22-.09-.47a3.18,3.18,0,0,1,.37-1,8.05,8.05,0,0,1,2.59-2.69,10.56,10.56,0,0,1,5.38-1.76,10.7,10.7,0,0,1,3.43.4,14.57,14.57,0,0,1,3.28,1.39,41.47,41.47,0,0,1,5.14,3.69,32.47,32.47,0,0,0,3.87,2.72,19.12,19.12,0,0,0,2.84,1.34C388.7,132.48,389.15,132.67,389.16,132.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.42,138.9a3.6,3.6,0,0,1-1.39.3,8.9,8.9,0,0,1-6.44-2.09,3.49,3.49,0,0,1-.95-1.06,13.22,13.22,0,0,1,1.11.87,10.09,10.09,0,0,0,6.27,2C388.88,138.94,389.41,138.85,389.42,138.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,146.25s-.2,0-.56-.13a15.08,15.08,0,0,1-1.46-.53,22.13,22.13,0,0,1-4.51-2.49,22.88,22.88,0,0,1-3.85-3.43,13.85,13.85,0,0,1-1-1.21A1.7,1.7,0,0,1,381,138a18.88,18.88,0,0,1,1.48,1.53,29.23,29.23,0,0,0,3.87,3.31,28.65,28.65,0,0,0,4.4,2.55C391.91,145.92,392.67,146.2,392.65,146.25Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.06,119.63c0,.05-.62.27-1.59.72a10,10,0,0,0-3.35,2.43,6,6,0,0,0-1.42,3.78,8.57,8.57,0,0,0,.28,1.7,1.34,1.34,0,0,1-.24-.41,4.16,4.16,0,0,1-.28-1.28,5.83,5.83,0,0,1,1.4-4,9,9,0,0,1,3.51-2.42A5.63,5.63,0,0,1,367.06,119.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.09,117.3s-.56.4-1.31,1.18A7.62,7.62,0,0,0,360,126.3c.34,1,.73,1.59.68,1.63s-.13-.12-.31-.38a6.37,6.37,0,0,1-.61-1.17,7.36,7.36,0,0,1,1.8-8.07,6,6,0,0,1,1-.81C362.92,117.34,363.08,117.28,363.09,117.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.44,152.35a4,4,0,0,1-2.44-.81,4,4,0,0,1-1.71-1.9c.09-.07.75.87,1.9,1.61S385.46,152.24,385.44,152.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.88,153.75a5.16,5.16,0,0,1-4.76-2.5,16.15,16.15,0,0,0,2.19,1.61A15.74,15.74,0,0,0,385.88,153.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.94,131.86a2,2,0,0,1-1-.34,4.8,4.8,0,0,1-1.75-1.76,4.69,4.69,0,0,1-.66-2.4,2,2,0,0,1,.18-1,5.84,5.84,0,0,1,.06,1,5.57,5.57,0,0,0,.72,2.23,5.51,5.51,0,0,0,1.58,1.73C350.6,131.66,351,131.8,350.94,131.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,129.72a6.62,6.62,0,0,1-1.69-2.14,6.36,6.36,0,0,1-1-2.54c.09,0,.55,1.09,1.28,2.37S352.11,129.66,352,129.72Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.81,146.06c.05.06-.44.45-1.15.72a2.36,2.36,0,0,1-1.35.25,5.57,5.57,0,0,1,1.24-.52C376.23,146.25,376.77,146,376.81,146.06Z",
    style: {
      fill: "#ce8679"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,147.68a8.88,8.88,0,0,1-3.19-.21,4.52,4.52,0,0,1,1.61,0A4.25,4.25,0,0,1,378,147.68Z",
    style: {
      fill: "#ce8679"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,148.8c0,.08-.39.15-.88.16s-.88-.06-.88-.14.39-.15.88-.16S350,148.72,350,148.8Z",
    style: {
      fill: "#ce8679"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.63,148c0,.07-.38-.06-.75-.28s-.65-.47-.61-.54.38.06.76.29S349.67,147.9,349.63,148Z",
    style: {
      fill: "#ce8679"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.58,133.35s-.52.16-1.32.48-1.87.86-3.09,1.39a8.38,8.38,0,0,1-3.34.78,4.2,4.2,0,0,1-1-.12,1.09,1.09,0,0,1-.36-.14c0-.06.53.1,1.39.06a9.64,9.64,0,0,0,3.22-.85c1.21-.53,2.3-1.06,3.14-1.32A4.12,4.12,0,0,1,366.58,133.35Z",
    style: {
      fill: "#ce8679"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.41,133.1a8,8,0,0,1-3.27,1.1,7.75,7.75,0,0,1-3.44-.12,33.05,33.05,0,0,0,3.4-.17A31.58,31.58,0,0,0,364.41,133.1Z",
    style: {
      fill: "#ce8679"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.8,159.76c-.07,0-.33-.6-1-.87a3,3,0,0,0-1.34-.07s.11-.16.38-.24a1.59,1.59,0,0,1,1.07,0,1.56,1.56,0,0,1,.81.71C367.83,159.57,367.83,159.75,367.8,159.76Z",
    style: {
      fill: "#ce8679"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.19,159.43c-.08,0-.24-.68-.94-1.12a3.4,3.4,0,0,0-1.4-.4s.15-.13.45-.15a1.81,1.81,0,0,1,1.11.3,2,2,0,0,1,.73.89C369.25,159.23,369.23,159.42,369.19,159.43Z",
    style: {
      fill: "#ce8679"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.63,135.83s4.17-16.24,4.52-17,5.08-7.85,16.2-9.75l9.17.12s13,4.36,15.3,7.56S392,135.34,392,135.34l-25.64-5.93-17.55,4Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.38,107.23l-2.53,0a2.59,2.59,0,0,0-2.41,1.53,8.05,8.05,0,0,0-.62,2.57c-.22,2.85-1.12,22.4-1.12,22.4l11.5-.38-.05-24.16,3.89.92-.05-.71a2.09,2.09,0,0,0-.47-1.17h0a2.08,2.08,0,0,0-1.54-.75Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.76,137.38l1.14-4.13,20.26-6.76,25.45,10.29-.47,3.23S367.44,131.89,344.76,137.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.89,130.18l-.77.73L343,135.36a4.17,4.17,0,0,0,2.35-.33c3.9-1.78,12.57-3.43,21.88-3.21,7.79.19,16,2.1,21.23,3.41.77.19,1.53.69,2.15.86a10.11,10.11,0,0,0,3.1.39l-8.14-5h0a14.16,14.16,0,0,0-10-4.61l-15.53-.5A14.14,14.14,0,0,0,349.89,130.18Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.76,135.61s.12-.14.4-.34a7.44,7.44,0,0,1,1.25-.77,22.37,22.37,0,0,1,5.13-1.7,57.63,57.63,0,0,1,17.72-.82c3.44.29,6.74.5,9.73,1a73.14,73.14,0,0,1,7.8,1.75c1.1.32,2.07.66,2.92,1a5.06,5.06,0,0,1,2,1.22,2,2,0,0,1,.56,1.39c0,.35-.11.51-.13.5a2.06,2.06,0,0,0-.62-1.71,5.18,5.18,0,0,0-2-1c-.84-.3-1.82-.6-2.91-.88-2.18-.55-4.83-1.14-7.77-1.6s-6.23-.62-9.69-.91a62.27,62.27,0,0,0-17.56.61,24.76,24.76,0,0,0-5.11,1.48C345.36,135.23,344.81,135.68,344.76,135.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,134.35a4.42,4.42,0,0,0,.5-.25l1.4-.8,5.12-3h0l0,0,1.18-1.54a8.52,8.52,0,0,1,1.35-1.54,5.17,5.17,0,0,1,1.9-1,9.64,9.64,0,0,1,2.32-.21c3.24-.06,6.81,0,10.55.19,3.48.14,6.81.34,9.86.54a6.71,6.71,0,0,1,2.14.36,5.39,5.39,0,0,1,1.73,1.08c.92,1,1.76,2,2.55,2.87l0,0h0L389.7,134l1.66.78a3.67,3.67,0,0,0,.6.25l-.56-.33-1.62-.85-6-3.06.05,0c-.79-.9-1.59-1.88-2.54-2.92a5.56,5.56,0,0,0-1.84-1.17,7.15,7.15,0,0,0-2.25-.4c-3.05-.22-6.38-.42-9.87-.57-3.74-.16-7.32-.24-10.57-.16a9.15,9.15,0,0,0-2.4.25,5.51,5.51,0,0,0-2,1.08,9.23,9.23,0,0,0-1.38,1.61l-1.16,1.55,0,0-5.05,3.1-1.36.87A3,3,0,0,0,343,134.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,124.41a3.21,3.21,0,0,0,.08-.8c0-.51,0-1.26.06-2.18,0-1.85,0-4.4,0-7.21,0-1.41,0-2.74,0-4,0-.6,0-1.18,0-1.73a.73.73,0,0,1,.8-.75l2.13.43a4.09,4.09,0,0,0,.79.11,2.72,2.72,0,0,0-.76-.26c-.5-.15-1.2-.34-2.13-.57a1,1,0,0,0-1.16,1c0,.55,0,1.13,0,1.74v4c0,2.81,0,5.36.08,7.21,0,.92,0,1.67.07,2.18A2.7,2.7,0,0,0,372.2,124.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.08,124a11,11,0,0,0,.38-2.37c.17-1.48.29-3.53.39-5.78s.18-4.31.22-5.79a15.36,15.36,0,0,0,0-2.4,13.56,13.56,0,0,0-.26,2.38c-.11,1.48-.23,3.53-.33,5.79s-.2,4.17-.27,5.78A17,17,0,0,0,361.08,124Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.29,165A199,199,0,0,0,259,185.71c2.38,9.52,10.2,24.82,10.54,31.95S263,270.35,263,270.35l45,11.56,33,26.76S438.16,322,438.16,321s3.4-110.6,3.4-108.49S402.33,216,402.33,216l-68.42-15.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.29,165,334,200.59h0l68.43,15.15h-.06c5.24-.19,10.6-.44,16.05-.74s11-.65,16.63-1.26c1.4-.16,2.81-.33,4.2-.59a8.13,8.13,0,0,0,2-.56.53.53,0,0,0,.13-.1s0,0,0,0,0,0,0,0c1,0,.26,0,.48,0v.06l0,.54,0,1.07c-.1,2.88-.19,5.78-.29,8.7q-.27,8.76-.56,17.77c-.74,24-1.52,49.33-2.33,75.41l-.1,3.39,0,.85V321a.36.36,0,0,1-.11.22c-.09.07-.06,0-.09.05a.54.54,0,0,1-.18,0,13.89,13.89,0,0,1-1.73-.07c-2.26-.18-4.49-.44-6.72-.69l-13.27-1.6-26-3.36-49.41-6.67h-.07l-.05,0-33-26.78.09.05L263,270.54l-.17,0,0-.18c2.44-16.4,4.58-31.28,6-44.42.17-1.65.34-3.26.44-4.85,0-.8.13-1.59.12-2.36,0-.39,0-.78,0-1.16s-.08-.76-.11-1.14a49.41,49.41,0,0,0-2.38-8.51c-1.92-5.33-3.92-10.12-5.53-14.52-.81-2.19-1.51-4.28-2.08-6.28s-1-3.9-1.34-5.66c-.74-3.53-1.25-6.54-1.64-9s-.65-4.3-.81-5.56-.22-1.9-.22-1.9.1.64.28,1.89.46,3.12.86,5.55.94,5.44,1.69,9c.39,1.76.8,3.66,1.37,5.65s1.29,4.07,2.1,6.26c1.62,4.38,3.64,9.16,5.57,14.5a49,49,0,0,1,2.42,8.56l.12,1.16c0,.39,0,.78,0,1.18,0,.79-.07,1.58-.11,2.38-.1,1.59-.27,3.21-.43,4.86-1.41,13.16-3.53,28-5.95,44.45l-.15-.22,45,11.53h.05l0,0,33,26.75-.12-.05,49.41,6.64,26,3.35L429.65,320c2.23.25,4.46.5,6.7.68a13.25,13.25,0,0,0,1.64.07s.05,0,.05,0,.08.13.06.14.29.05-.2,0v-.27l0-.42,0-.85.1-3.39c.81-26.08,1.6-51.39,2.35-75.41q.28-9,.57-17.78.14-4.38.29-8.69l0-1.08,0-.54v-.07c.22,0-.48,0,.49-.05v.07a.47.47,0,0,1-.1.26,1,1,0,0,1-.28.24,8.67,8.67,0,0,1-2.13.61c-1.42.26-2.83.44-4.24.59-5.64.61-11.2.94-16.65,1.25s-10.81.54-16.06.73h-.06l-68.41-15.24h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.81,211.32l-3-3.82a4.18,4.18,0,0,1-1.12-2.27c0-.86.73-1.79,1.56-1.57a2.26,2.26,0,0,1,.75-4.34,6.71,6.71,0,0,1-1.15-2.43,2.8,2.8,0,0,1,.67-2.51,2.83,2.83,0,0,1,2.9-.41,7.35,7.35,0,0,1,2.48,1.81c1.13,1.1,2.21,2.26,3.23,3.46a4,4,0,0,1,.9,1.46,1.4,1.4,0,0,1-.47,1.55,3.83,3.83,0,0,1,2.68,4.73c.68,1.31-.66,2.93-2.12,3.1a6.94,6.94,0,0,1-4.13-1.33,2.41,2.41,0,0,1,2,2.34,2.45,2.45,0,0,1-2,2.32,2.48,2.48,0,0,1-2.61-1.66",
    style: {
      fill: "#f8ad91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.4,234.31a3.3,3.3,0,0,1,2.16,5.54c1,.48,1.21,1.87.9,2.94s-1,2-1.32,3.07c-.49,1.72-.06,3.81-1.28,5.11-1,1.05-2.65,1.08-4.08.88a42.4,42.4,0,0,1-4.73-1,6.32,6.32,0,0,1-1.95-.75,2.12,2.12,0,0,1-1-1.73,1.3,1.3,0,0,1,1.35-1.28,2,2,0,0,1-.53-3.84,1.84,1.84,0,0,1,.55-2.38,7.18,7.18,0,0,1,2.48-1,13.63,13.63,0,0,0,7.31-5.61",
    style: {
      fill: "#f8ad91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.19,218.19a.79.79,0,0,1,0,.25c0,.19,0,.43,0,.73,0,.69,0,1.63,0,2.83,0,2.5,0,6,.09,10.39,0,8.82.05,20.93.08,34.31s-.06,25.49-.08,34.31c0,4.35-.06,7.89-.08,10.39,0,1.2,0,2.14-.05,2.83,0,.3,0,.54,0,.74a.87.87,0,0,1,0,.25.72.72,0,0,1,0-.25c0-.2,0-.44,0-.74,0-.69,0-1.63,0-2.83,0-2.49-.05-6-.08-10.39,0-8.82,0-20.93-.08-34.31s.05-25.49.07-34.3c0-4.36.06-7.9.08-10.4,0-1.2,0-2.14.05-2.83,0-.3,0-.54,0-.73A.67.67,0,0,1,401.19,218.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.67,205.94a1.11,1.11,0,0,1,0,.26c0,.2.05.46.08.77.07.72.15,1.71.26,3,.21,2.62.51,6.34.88,10.92.76,9.25,1.8,22,3,36s2.37,26.74,3.2,36c.41,4.58.75,8.29,1,10.91.11,1.26.19,2.25.25,3l.05.77a.86.86,0,0,1,0,.26,1,1,0,0,1-.05-.26l-.1-.76c-.09-.72-.2-1.71-.35-3-.27-2.61-.67-6.33-1.15-10.89-.94-9.2-2.15-21.92-3.35-36s-2.17-26.8-2.81-36c-.3-4.58-.54-8.3-.71-10.93-.07-1.26-.12-2.25-.16-3,0-.32,0-.57,0-.78A1,1,0,0,1,333.67,205.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.55,190c.14,0,1.38,20.06,2.77,44.82s2.39,44.86,2.25,44.86-1.38-20.06-2.77-44.83S302.41,190,302.55,190Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M320.09,345.14a3.47,3.47,0,0,0,.63-2.18,22.44,22.44,0,0,1,0-2.32c.19-1.56,1.14-2.9,1.78-4.33a11.17,11.17,0,0,0,.63-7.23c-.14-.59-.48-1.28-1.09-1.3a9,9,0,0,1-.76,4.15c-.63,1.31-1.69,2.35-2.39,3.62a9.81,9.81,0,0,0-1.11,4.73,28.53,28.53,0,0,0,.49,4.88"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M315.76,345.09l3.12-.08h0c0-2.55.06-6.65.14-6.95a28.36,28.36,0,0,1,2.24-3.71,27,27,0,0,0,1.5-2.62l-6-1.05,1.66-4.73-.79-.19s-3.88,2.22-4.58,4.46,1,4.55,1.28,5.3,1.74,3.13,1.49,8.7l0,.87h0",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,331.26l1.32-4.73.55.13s1.2,2.91.51,5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.33,335.58h.07l.2,0,.74.08L319,336l0-.06c-.15.21-.3.44-.45.7a2.77,2.77,0,0,0-.33.83c-.06.6-.06,1.23-.08,1.89,0,1.31,0,2.74,0,4.24a1.07,1.07,0,0,1-.09.56.9.9,0,0,1-.37.42.74.74,0,0,1-.95-.09.76.76,0,0,1-.21-.45c0-.17,0-.37,0-.55,0-.36,0-.72,0-1.07,0-1.4,0-2.66,0-3.71a2.44,2.44,0,0,0-.12-.74c-.06-.22-.14-.43-.21-.62-.15-.37-.28-.69-.4-.95s-.21-.45-.28-.58l-.08-.15s0,0,0-.05l0,.06.07.15c.06.15.15.35.26.6s.24.58.38.95c.07.19.14.4.2.62a2.3,2.3,0,0,1,.11.71v4.79c0,.19,0,.37,0,.56a.89.89,0,0,0,.23.52.87.87,0,0,0,1.08.11,1.05,1.05,0,0,0,.43-.48,1.4,1.4,0,0,0,.11-.63c0-1.49,0-2.92,0-4.24,0-.65,0-1.28.07-1.86a2.42,2.42,0,0,1,.31-.8c.14-.25.29-.48.44-.7l.05-.06H319l-2.73-.22-.73-.06h-.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "316.13 333.38 318.83 333.88 319.69 332.53 316.95 332.06 316.13 333.38"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M319.29,332.16c-.06,0-.38.38-.73.93a3.31,3.31,0,0,0-.54,1.05c.05,0,.38-.38.73-.93A3.31,3.31,0,0,0,319.29,332.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.47,332c-.05,0-.38.38-.72.93a3.31,3.31,0,0,0-.54,1.05,6.42,6.42,0,0,0,1.26-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.74,331.78c-.05,0-.37.38-.72.93a3.31,3.31,0,0,0-.54,1.05,3.22,3.22,0,0,0,.73-.93A3.15,3.15,0,0,0,317.74,331.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.8,331.74h-.09l-.28-.05-1-.18-3.35-.58-3.35-.57-1-.18-.28-.05-.09,0s0,0,.1,0l.28,0,1,.15c.86.13,2.05.32,3.35.54s2.49.43,3.35.6l1,.21.27.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.07,339.86a6.35,6.35,0,0,1-.87,1,13.09,13.09,0,0,1-1.11,1.05l-1.64,1.2a17.44,17.44,0,0,1-11.32,2.29,34,34,0,0,1-11.11-3.5c-1.33-.67-2.38-1.27-3.1-1.7a5.65,5.65,0,0,1-1.07-.72A5.82,5.82,0,0,1,301,340c.74.37,1.82.91,3.16,1.54a36.93,36.93,0,0,0,11,3.31,17.68,17.68,0,0,0,11.07-2.09l1.65-1.11c.48-.33.82-.71,1.15-1A6.45,6.45,0,0,1,330.07,339.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.36,364.69s-.15.32-.69.6a2.89,2.89,0,0,1-2.49,0,4.49,4.49,0,0,1-2.22-3,16.94,16.94,0,0,1-.25-4.49c.07-3.15.16-6,.25-8.07a21.11,21.11,0,0,1,.26-3.34,21.5,21.5,0,0,1,.11,3.35c0,2.07,0,4.92-.1,8.07a18,18,0,0,0,.2,4.36,4.18,4.18,0,0,0,1.91,2.75,2.8,2.8,0,0,0,2.25.17A6.17,6.17,0,0,0,320.36,364.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388.08,183.9c-.3,8.85-4.51,18.44-2.61,27.39a33.12,33.12,0,0,0,2.61-27.39"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Crane--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.32,198.43a3.89,3.89,0,0,0-7.07,0l-6.08.5L545.32,211l3.85-7.09a3.87,3.87,0,0,0,3.15-5.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.22,180.87l4-1.69-9.57-2.41a3.9,3.9,0,1,0-.91,5.19l9.1,5.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.84,299.86l0-.08L528.13,177.31l-.37-.69-10.35,4.72L567,311.93l0,.07,29.51,46.91.59-.09.68-.1.54-.08-6.11-9.7,3.57-9.19,9.44,3.5L609.36,357l.5-.07.63-.1.55-.08Zm4.25,19.84-11.79-3,6.84-13.35Zm-12.83-3.3-14.51-3.72,21.41-9.75Zm5.47-18.83-15.06-4.16,6.18-12.4Zm-16.09-4.45-13.27-3.66,19.52-8.89ZM580,277.56l-13.88-4.84,4.95-11.82Zm-14.87-5.19-12.19-4.25,17.27-7.87Zm4-15.13-12.64-5.46,3.74-11.13Zm-13.61-5.88-10.82-4.67L559.31,240Zm2.9-14.09-.07,0L547,231.16l2.53-10.5ZM547.2,216.41l-9.92-6.66,1.32-9.38Zm-10.88-7.31-8-5.35,9.32-4.25Zm-8.45-28.73,8.42,15.7-8.66-7.3Zm-1.61,19.57-6.1-16.09,6.41,5.4Zm.35-12-6.88-5.79,7.13-3.25Zm1,2.2,8.33,7-8.64,3.94Zm.54,14.75,8,5.39-1.61,11.52Zm9,6,9.64,6.48-11.27,5.13Zm11.51,8.79-2.63,11-9.79-5.3Zm-12.24,6.95,9.35,5.06-2.88,12Zm10.31,5.57,10.42,5.64-13.23,6Zm-2.32,15.49,10.78,4.66L550.92,265Zm11.74,5.08L568.2,258l-16.33,7.44Zm-3.63,16.3,12.22,4.26-5.56,13.28Zm13.22,4.6,13.22,4.61-18.73,8.54Zm-5.16,16.64,13.61,3.76L567.24,308Zm14.64,4L590,298.45l-21.77,9.92Zm-5.25,19.19,14.83,3.81-5.58,10.89Zm15.87,4.08,12.11,3.11L580,328.89Zm5.69,30.2-7.92-12.59,11.2,4.14Zm3.65-9.42-12.49-4.63-.3-.48,17.44-7.94.18.6Zm1,.36,4.33-11.18,4.35,14.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.32,235.26s0-.35,0-1,0-1.7,0-3c0-2.67,0-6.57,0-11.58,0-10,0-24.46-.05-42.08v-.11h.11l18.43-1.94h.07l.05.05,48,53.63,69.83,78.17L664.81,331l5.74,6.46,1.48,1.68c.34.38.5.58.5.58s-.18-.18-.52-.56l-1.51-1.66-5.78-6.42c-5-5.59-12.25-13.67-21.21-23.65l-69.9-78.11-48-53.65.11,0-18.44,1.92.11-.12c0,17.62,0,32.05-.05,42.08,0,5,0,8.91,0,11.58,0,1.32,0,2.34,0,3S507.32,235.26,507.32,235.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.66,
    y: 218.82,
    width: 2.94,
    height: 6.31,
    rx: 0.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.12,226.11h-9.66a1.08,1.08,0,0,1-1.08-1.08h0a1.07,1.07,0,0,1,1.08-1.07h9.66A1.07,1.07,0,0,1,513.2,225h0A1.08,1.08,0,0,1,512.12,226.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508,243.4l0-1.37-1.42.6a8.69,8.69,0,0,0,0,1.53.49.49,0,0,0,.05.24.73.73,0,0,0,.35.24,2.78,2.78,0,0,1,1.46,1.28,1.68,1.68,0,0,1-1,2.35,1.74,1.74,0,0,1-2.17-1.17c0-.23,0-.57-.33-.6-.48-.05-.68.64-.67,1a3,3,0,0,0,2.88,2.79,3.05,3.05,0,0,0,1.63-.36,3.15,3.15,0,0,0,1.52-2.15C510.76,245.05,507.85,243.58,508,243.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.21,242.72l6.18-14.87a2,2,0,0,0-1.88-2.83H501.15a2,2,0,0,0-1.89,2.83l6.18,14.87A2,2,0,0,0,509.21,242.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.78,226.08l-1.6,1.6c0,.06,0,.12,0,.18l.52,1.25,3-3Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.75 226.08 505.76 226.08 501.32 230.52 501.9 231.92 507.75 226.08",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "511.99 233.76 513.4 230.36 504.82 238.95 505.4 240.35 511.99 233.76",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.58,237.17,506,241.76l.15.37a1.25,1.25,0,0,0,.75.71l2.27-2.27Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "511.72 226.08 509.73 226.08 502.48 233.33 503.07 234.73 511.72 226.08",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.54,227.24a1.27,1.27,0,0,0-.21-.59,1.25,1.25,0,0,0-.71-.48l-10,10,.58,1.4Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.54,336.55h8.17a2.64,2.64,0,0,1,2.64,2.64v3.64a0,0,0,0,1,0,0H664.9a0,0,0,0,1,0,0v-3.64A2.64,2.64,0,0,1,667.54,336.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.39,341.26h-2.2V328.14a5.81,5.81,0,0,1,.26-1.71l1.11-3.43a.08.08,0,0,1,.15,0l1.3,2.3-.34,1.07a5.52,5.52,0,0,0-.28,1.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.75,343.65a4.83,4.83,0,0,0-3.6-2.89l-55.17,0v-9.19a2.23,2.23,0,0,0-2.24-2.23H608.09a2.25,2.25,0,0,0-2.13,1.55l-.79,2.53h3a2.33,2.33,0,0,1,1.78.82,2.2,2.2,0,0,1,.47,1.87l-2.85,13.52a2.3,2.3,0,0,1-2.25,1.79h-5.67a8.61,8.61,0,0,0,.16,2.58l.31,1.35-14.6,2.88a.6.6,0,0,0-.47.46l-1.38,3.69a2.35,2.35,0,0,0-.19.53v0h0c-.29,1.22-.08,3.26.66,3.26h15.64l-.69.77-.88,2.74h99.35C697.54,360.77,697.3,347.38,695.75,343.65Zm-68.85-8.39-1.47,13.28c0,.17,0,.34-.07.5a5.85,5.85,0,0,1-5.81,4.57H613a2,2,0,0,1-2-2.45l3.08-16a2.25,2.25,0,0,1,2.19-1.79h8.93a1.68,1.68,0,0,1,1.67,1.87Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.33,376.3l-42.28.59c-.27,0-.76-.82-.76-1.09v-4.72a.5.5,0,0,1,.5-.5h42.54a.5.5,0,0,1,.5.5v4.72A.51.51,0,0,1,651.33,376.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.9,335.25l-1.47,13.29c0,.17,0,.33-.07.5a5.86,5.86,0,0,1-5.81,4.57H613a2,2,0,0,1-2-2.44l3.08-16a2.26,2.26,0,0,1,2.19-1.79h8.93a1.68,1.68,0,0,1,1.67,1.87Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.55,370.82a2.28,2.28,0,0,0-.13-1.06H598.3a2.28,2.28,0,0,0-.13,1.06Z",
    style: {
      fill: "#242424"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M606,330.86l-6,18.53a8.9,8.9,0,0,0-.22,4.58l2.55,11.85H637V331.54a2.23,2.23,0,0,0-2.24-2.23H608.09A2.23,2.23,0,0,0,606,330.86Z",
    style: {
      fill: "#242424"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M613,353.61a2,2,0,0,1-2-2.45l3.08-16a2.25,2.25,0,0,1,2.19-1.79h8.93a1.68,1.68,0,0,1,1.67,1.87l-1.47,13.28c0,.17,0,.34-.07.5a5.85,5.85,0,0,1-5.81,4.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.61,351.42a8.41,8.41,0,0,1,.4-1.92l5.18-16.09h3a2.3,2.3,0,0,1,1.78.83,2.17,2.17,0,0,1,.47,1.86l-2.86,13.53a2.28,2.28,0,0,1-2.24,1.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.6,372.3H598.29c-.76,0-.76-2.75,0-2.75H697.6C698.36,369.55,698.36,372.3,697.6,372.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.06,341.44s0,.05,0,.14V342q0,.6,0,1.65c0,1.46-.11,3.53-.19,6.08s-.2,5.63-.31,9c0,.85-.07,1.72-.1,2.61a6,6,0,0,1-.58,2.7,3.73,3.73,0,0,1-2.29,1.72,10.2,10.2,0,0,1-2.92.34l-20.08-.38-6.08-.15-1.65-.05-.43,0h-.15l.15,0h2.08l6.09.05,20.07.29a10.16,10.16,0,0,0,2.83-.33,3.46,3.46,0,0,0,2.12-1.57,5.83,5.83,0,0,0,.55-2.57c0-.89.07-1.76.11-2.61.14-3.39.27-6.44.38-9s.21-4.61.28-6.07c0-.7.07-1.25.09-1.66l0-.43C637.05,341.49,637.06,341.44,637.06,341.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.77,366c-.09,0-.16-2.91-.16-6.5s.07-6.51.16-6.51.15,2.91.15,6.51S608.85,366,608.77,366Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614,329.42a5.92,5.92,0,0,1-.11.94c-.09.6-.23,1.47-.42,2.54-.38,2.14-.95,5.09-1.68,8.33s-1.46,6.15-2,8.25c-.29,1-.53,1.9-.71,2.48a4.87,4.87,0,0,1-.3.89,6,6,0,0,1,.19-.92c.16-.65.36-1.49.61-2.5.52-2.11,1.22-5,1.94-8.27s1.34-6.17,1.77-8.3c.21-1,.38-1.88.52-2.53A5.11,5.11,0,0,1,614,329.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.46,358.89a1.61,1.61,0,0,0,.54-.22,1,1,0,0,0,.37-.54,1.15,1.15,0,0,0-.1-.84,1,1,0,0,0-.87-.45h-1.31l-3,0a.89.89,0,0,0-.89.82.91.91,0,0,0,.59,1,1,1,0,0,0,.29.06h1l1.14,0,1.67,0a2.55,2.55,0,0,1,.61.06,2.55,2.55,0,0,1-.61.06c-.4,0-1,0-1.67.05L622,359h-1a1.24,1.24,0,0,1,0-2.47h3l1.31,0a1.13,1.13,0,0,1,1.05.6,1,1,0,0,1,.14.52,1.22,1.22,0,0,1-.06.47,1.1,1.1,0,0,1-.46.59,1,1,0,0,1-.45.14C625.51,358.92,625.46,358.9,625.46,358.89Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.06,344.62c0,.08-4,.15-9.06.15s-9.07-.07-9.07-.15,4.06-.16,9.07-.16S691.06,344.53,691.06,344.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.06,346.42c0,.08-4,.15-9.06.15s-9.07-.07-9.07-.15,4.06-.15,9.07-.15S691.06,346.34,691.06,346.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.06,348.22c0,.09-4,.16-9.06.16s-9.07-.07-9.07-.16,4.06-.15,9.07-.15S691.06,348.14,691.06,348.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.06,350c0,.08-4,.15-9.06.15s-9.07-.07-9.07-.15,4.06-.15,9.07-.15S691.06,349.94,691.06,350Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.06,351.83c0,.09-4,.15-9.06.15s-9.07-.06-9.07-.15,4.06-.15,9.07-.15S691.06,351.75,691.06,351.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.06,353.64c0,.08-4,.15-9.06.15s-9.07-.07-9.07-.15,4.06-.15,9.07-.15S691.06,353.55,691.06,353.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.06,355.44c0,.09-4,.15-9.06.15s-9.07-.06-9.07-.15,4.06-.15,9.07-.15S691.06,355.36,691.06,355.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.13,398.3c-5.45,0-10-5.25-10-10.69a10.34,10.34,0,0,1,10.24-10l87.65-4a11.81,11.81,0,0,1,11,6.13,11.69,11.69,0,0,1,1,8.13c-2.29,10.59-11.12,10.46-14.54,10.23S588.13,398.3,588.13,398.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.13,
    cy: 387.54,
    r: 8.19,
    transform: "matrix(0.93, -0.36, 0.36, 0.93, -99.41, 234.64)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675.44,
    cy: 385.88,
    r: 10.59,
    transform: "translate(-75.03 590.63) rotate(-45)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.62,375.62l-.22,0-.67.07-2.58.26c-2.23.22-5.47.51-9.48.84-8,.66-19.09,1.42-31.34,2s-23.36.75-31.4.8c-4,0-7.27,0-9.52,0l-2.59,0-.67,0h-.23l.23,0h.67l2.59,0,9.52-.09c8-.1,19.13-.35,31.38-.89s23.33-1.27,31.34-1.87l9.49-.75,2.58-.2.67,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.25,395.47c0,.08-19.06.15-42.57.15s-42.57-.07-42.57-.15,19.06-.15,42.57-.15S673.25,395.38,673.25,395.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.73,365.67a17.54,17.54,0,0,1-.61-2.06c-.35-1.27-.87-3-1.4-5a42,42,0,0,1-1.09-5.08,11,11,0,0,1-.09-1.57,1.93,1.93,0,0,1,.07-.58s0,.82.23,2.12.65,3.08,1.18,5,1,3.73,1.31,5c.15.65.27,1.17.33,1.54A2.44,2.44,0,0,1,602.73,365.67Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.61,392.42a2.57,2.57,0,0,1-.61-.4,7.14,7.14,0,0,1-1.36-1.44,8.24,8.24,0,0,1-1.28-2.66,8,8,0,0,1-.16-3.6,8.14,8.14,0,0,1,3.68-5.27,7,7,0,0,1,1.81-.82,3,3,0,0,1,.71-.15,12,12,0,0,0-2.4,1.15,8.44,8.44,0,0,0-2.08,2,8.07,8.07,0,0,0-1.42,3.17,7.91,7.91,0,0,0,.13,3.48,8.66,8.66,0,0,0,1.18,2.61A11.39,11.39,0,0,0,669.61,392.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.6,342.66a56.76,56.76,0,0,1-4.55,3.47,52.3,52.3,0,0,1-4.73,3.24,54.86,54.86,0,0,1,4.55-3.48A53.35,53.35,0,0,1,623.6,342.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.3,340.18a39.45,39.45,0,0,1-4,3,41.23,41.23,0,0,1-4.14,2.71,39.84,39.84,0,0,1,4-3A43.47,43.47,0,0,1,624.3,340.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.23,344a10.72,10.72,0,0,1-2,1.59,11.28,11.28,0,0,1-2.19,1.34,11.46,11.46,0,0,1,2-1.59A11.12,11.12,0,0,1,607.23,344Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.41,341.69a15.69,15.69,0,0,1-2.3,2,15.15,15.15,0,0,1-2.48,1.73,16,16,0,0,1,2.29-2A15,15,0,0,1,608.41,341.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.68,355.84a35.39,35.39,0,0,1-6.51,0,35.39,35.39,0,0,1,6.51,0Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.5,394.49a2.53,2.53,0,0,1-.72-.15,6.68,6.68,0,0,1-1.78-.88,7.36,7.36,0,0,1-2.07-2.12,7.24,7.24,0,0,1-1.19-3.42,7.33,7.33,0,0,1,.69-3.56,7.65,7.65,0,0,1,1.76-2.39,6.45,6.45,0,0,1,1.64-1.12,2.19,2.19,0,0,1,.69-.25,10,10,0,0,0-2.19,1.52,7.74,7.74,0,0,0-1.64,2.35,6.84,6.84,0,0,0,.47,6.72,7.64,7.64,0,0,0,2,2.09A9.91,9.91,0,0,0,586.5,394.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.91,362.19c0,.08-3.15.15-7,.15s-7.05-.07-7.05-.15,3.16-.15,7.05-.15S598.91,362.1,598.91,362.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.35,189.75,530,178.35a7,7,0,0,0-9.35-3.41h0a7,7,0,0,0-3.41,9.36l5.31,11.4a.43.43,0,0,0,.56.21l12-5.59A.43.43,0,0,0,535.35,189.75Z",
    style: {
      fill: "#242424"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Briefcase--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "588.94 482.77 512.33 482.77 512.33 429.54 583.15 429.54 588.94 482.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.68,
    y: 429.54,
    width: 76.62,
    height: 53.24,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.93,429.54s-.26.16-.77.43l-2.2,1.2c-1.91,1.06-4.63,2.67-7.94,4.73s-7.24,4.57-11.86,6.94a48.71,48.71,0,0,1-15.95,5.25,30,30,0,0,1-8.74-.17,34.94,34.94,0,0,1-7.81-2.28,53.69,53.69,0,0,1-11.82-7c-3.11-2.38-5.47-4.48-7.11-5.93L504.87,431a4.64,4.64,0,0,1-.62-.62,5.69,5.69,0,0,1,.69.54l1.93,1.62c1.67,1.4,4.07,3.46,7.19,5.79a54.71,54.71,0,0,0,11.78,6.86,32,32,0,0,0,16.31,2.38,49,49,0,0,0,15.8-5.17c4.59-2.33,8.53-4.82,11.88-6.82s6.09-3.59,8-4.59c1-.51,1.73-.88,2.26-1.12A4.64,4.64,0,0,1,580.93,429.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.57,429.57a17.72,17.72,0,0,0-2.31-4,12.8,12.8,0,0,0-3.82-3.19,12.51,12.51,0,0,0-5.87-1.49,12.36,12.36,0,0,0-5.89,1.43,13,13,0,0,0-3.85,3.15,17.67,17.67,0,0,0-2.34,4s0-.12,0-.33a8.68,8.68,0,0,1,.29-.89,12.36,12.36,0,0,1,1.71-3,13,13,0,0,1,3.92-3.34,12.73,12.73,0,0,1,12.21.06,12.73,12.73,0,0,1,3.88,3.38,11.78,11.78,0,0,1,1.68,3,6.88,6.88,0,0,1,.28.9A1.27,1.27,0,0,1,555.57,429.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.63,456.25a7.52,7.52,0,0,1-.06-1c0-.72,0-1.61-.07-2.68,0-2.26-.1-5.4-.12-9l.25.25h-4.72c.51-.52.14-.14.26-.25h0v.91c0,.31,0,.62,0,.92v1.81c0,1.18,0,2.32,0,3.4,0,2.12,0,4-.06,5.65l-.17-.18c1.43,0,2.59.07,3.41.1a11.73,11.73,0,0,1,1.31.08,6.29,6.29,0,0,1-1.2.08c-.81,0-2,.08-3.52.1h-.18v-.18c0-1.61,0-3.53-.06-5.65,0-1.08,0-2.22,0-3.4v-3.64h0c.12-.12-.26.25.27-.27h5v.25c0,3.73-.07,7-.11,9.21,0,1-.06,1.91-.07,2.62A5,5,0,0,1,542.63,456.25Z",
    style: {
      fill: "#455a64"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.bb63780a7ace74f25555eee68a5b9bc4.svg";
export { ForwardRef as ReactComponent };